var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _g, _path838, _path839, _g2, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 275.328H0V275.508H360V275.328Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323.928 286.913H300.082V287.093H323.928V286.913Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.478 288.871H232.222V289.051H238.478V288.871Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M299.362 280.231H285.545V280.411H299.362V280.231Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.868 281.441H37.7712V281.621H68.868V281.441Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8408 281.441H75.2832V281.621H79.8408V281.441Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.108 284.479H94.6584V284.659H162.108V284.479Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.64 243.216H31.6152C30.5261 243.214 29.4823 242.78 28.7128 242.009C27.9434 241.239 27.5112 240.194 27.5112 239.105V43.6752C27.5207 42.5923 27.957 41.5569 28.7255 40.7939C29.4939 40.0309 30.5323 39.6018 31.6152 39.6H170.64C171.73 39.6 172.776 40.0331 173.547 40.8041C174.318 41.5751 174.751 42.6208 174.751 43.7112V239.105C174.751 240.195 174.318 241.241 173.547 242.012C172.776 242.783 171.73 243.216 170.64 243.216ZM31.6152 39.744C30.5739 39.7459 29.5758 40.1609 28.8401 40.8979C28.1044 41.635 27.6912 42.6338 27.6912 43.6752V239.105C27.6912 240.146 28.1044 241.145 28.8401 241.882C29.5758 242.619 30.5739 243.034 31.6152 243.036H170.64C171.682 243.034 172.681 242.619 173.418 241.882C174.155 241.146 174.569 240.147 174.571 239.105V43.6752C174.569 42.6331 174.155 41.6343 173.418 40.8975C172.681 40.1607 171.682 39.7459 170.64 39.744H31.6152Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M326.383 243.216H187.351C186.261 243.214 185.217 242.78 184.446 242.01C183.676 241.239 183.242 240.195 183.24 239.105V43.6752C183.251 42.5917 183.689 41.5563 184.459 40.7934C185.228 40.0306 186.268 39.6018 187.351 39.6H326.383C327.465 39.6037 328.501 40.0336 329.268 40.7964C330.035 41.5592 330.471 42.5936 330.48 43.6752V239.105C330.48 240.193 330.049 241.236 329.281 242.007C328.513 242.777 327.471 243.212 326.383 243.216ZM187.351 39.744C186.309 39.7459 185.31 40.1607 184.574 40.8975C183.837 41.6343 183.422 42.6331 183.42 43.6752V239.105C183.422 240.147 183.837 241.146 184.574 241.882C185.31 242.619 186.309 243.034 187.351 243.036H326.383C327.425 243.034 328.424 242.619 329.161 241.882C329.898 241.146 330.312 240.147 330.314 239.105V43.6752C330.312 42.6331 329.898 41.6343 329.161 40.8975C328.424 40.1607 327.425 39.7459 326.383 39.744H187.351Z",
    fill: "#EBEBEB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M240.71 110.65H230.558V91.1376L239.918 92.1888L240.12 92.448L240.314 92.2392L257.393 94.1544L257.551 94.3488L257.702 94.1832L292.075 98.0424V252.619H301.594V84.6792H228.65V110.65H219.139V115.69H240.739L240.71 110.65ZM292.097 96.1272L286.841 95.5368L292.097 88.3368V96.1272ZM291.046 86.58L285.487 94.1616L279.086 86.58H291.046ZM283.846 95.22L272.038 93.8952L277.762 88.0128L283.846 95.22ZM276.48 86.58L270.439 92.7936L264.802 86.58H276.48ZM268.56 93.4848L259.38 92.4552L263.52 87.984L268.56 93.4848ZM262.282 86.58L257.688 91.44L253.836 86.58H262.282ZM255.802 92.052L249.754 91.368L252.634 88.0632L255.802 92.052ZM251.417 86.58L248.314 90.1224L245.491 86.58H251.417ZM246.593 91.0152L241.985 90.4968L244.224 88.0416L246.593 91.0152ZM242.993 86.58L240.307 89.5176L237.974 86.58H242.993ZM238.334 90.0864L235.145 89.7336L236.7 88.0416L238.334 90.0864ZM235.454 86.58L233.748 88.4232L232.394 86.58H235.454ZM230.616 87.3792L232.099 89.388L230.616 89.2224V87.3792Z",
    fill: "#F0F0F0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M250.229 111.917H247.68V240.71H280.67V108.108H278.136V120.161H265.45V113.818H263.52V120.161H250.2L250.229 111.917ZM265.45 123.336H278.143V130.32H265.45V123.336ZM250.229 123.336H263.52V130.32H250.2L250.229 123.336Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.45 120.96V72H55.4399V269.078H65.1887V85.752L100.548 81.792L100.706 81.9576L100.865 81.756L118.433 79.7832L118.627 79.9992L118.836 79.74L128.491 78.6528V120.96H118.08V126.18H140.263V120.96H130.45ZM79.9199 75.42L85.8023 81.4752L73.6559 82.836L79.9199 75.42ZM71.9999 81.7632L66.2831 73.9656H78.5879L71.9999 81.7632ZM81.2303 73.9656H93.2399L87.4439 80.352L81.2303 73.9656ZM128.498 74.7864V76.6872L126.972 76.86L128.498 74.7864ZM125.273 75.8664L123.523 73.9656H126.67L125.273 75.8664ZM120.953 73.9656L118.548 76.9896L115.79 73.9656H120.953ZM113.213 73.9656L110.333 77.6088L107.15 73.9656H113.213ZM104.573 73.9656L100.613 78.9624L95.9255 73.9656H104.573ZM65.2175 75.8016L70.6319 83.1816L65.2175 83.7864V75.8016ZM89.4671 81.0648L94.5935 75.4128L98.9135 80.0064L89.4671 81.0648ZM105.84 75.492L108.814 78.8904L102.593 79.6104L105.84 75.492ZM112.061 78.5304L114.502 75.4704L116.806 77.9976L112.061 78.5304ZM122.242 75.4704L123.847 77.2056L120.564 77.5728L122.242 75.4704Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.259 130.738H94.5792V124.214H92.6208V130.738H79.5456V118.339H76.9392V254.722H110.88V122.242H108.266L108.259 130.738ZM92.5992 141.178H79.5456V133.978H92.5992V141.178ZM108.259 141.178H94.5792V133.978H108.259V141.178Z",
    fill: "#EBEBEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M312.487 274.954V241.567H309.636V225.655H305.46V170.345H299.426V163.21L286.546 157.205V150.005H284.76V170.345H282.262V225.655H279.763V196.574H272.988V181.584H271.094V225.655H265.946V208.886H262.555V204.602H254.7V189.972H250.409V179.626H245.117V164.549H243.23V179.626H237.953V189.972H233.647V204.602H225.799V208.886H222.408V225.655H218.39V204.602H210.535V159.286H208.037V154.289H191.268V159.286H187.697V192.11H173.426V195.322H168.077V197.82H173.426V210.672H158.436V167.846H155.225V158.746H148.27V126.454H146.304V158.746H141.307V167.846H112.018V164.851H110.239V185.191H107.741V185.551H106.236V205.891H103.738V211.421H98.4601V196.43H96.5664V232.121H94.4641V217.13H92.5705V240.502H91.4185V223.733H88.0273V219.449H80.1793V204.818H75.8809V194.472H70.5961V179.395H68.7097V194.472H63.4249V204.818H59.1265V219.449H51.2713V223.733H47.8801V240.149H47.2753V240.502H45.5977V274.954H312.487Z",
    fill: "#E0E0E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.385 169.848H128.362V171.871H130.385V169.848Z",
    fill: "#F5F5F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.385 173.239H128.362V175.262H130.385V173.239Z",
    fill: "#F5F5F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.385 186.797H128.362V188.82H130.385V186.797Z",
    fill: "#F5F5F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130.385 190.188H128.362V192.211H130.385V190.188Z",
    fill: "#F5F5F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M130.385 193.579H128.362V195.602H130.385V193.579Z",
    fill: "#F5F5F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.385 203.746H128.362V205.769H130.385V203.746Z",
    fill: "#F5F5F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.385 207.137H128.362V209.16H130.385V207.137Z",
    fill: "#F5F5F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M133.596 183.406H131.573V185.429H133.596V183.406Z",
    fill: "#F5F5F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M133.596 186.797H131.573V188.82H133.596V186.797Z",
    fill: "#F5F5F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M133.596 190.188H131.573V192.211H133.596V190.188Z",
    fill: "#F5F5F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M133.596 193.579H131.573V195.602H133.596V193.579Z",
    fill: "#F5F5F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M133.596 196.97H131.573V198.994H133.596V196.97Z",
    fill: "#F5F5F5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M133.596 203.746H131.573V205.769H133.596V203.746Z",
    fill: "#F5F5F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M133.596 207.137H131.573V209.16H133.596V207.137Z",
    fill: "#F5F5F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M136.807 169.848H134.784V171.871H136.807V169.848Z",
    fill: "#F5F5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M136.807 173.239H134.784V175.262H136.807V173.239Z",
    fill: "#F5F5F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M136.807 176.63H134.784V178.654H136.807V176.63Z",
    fill: "#F5F5F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M136.807 180.022H134.784V182.045H136.807V180.022Z",
    fill: "#F5F5F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M136.807 183.406H134.784V185.429H136.807V183.406Z",
    fill: "#F5F5F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M136.807 186.797H134.784V188.82H136.807V186.797Z",
    fill: "#F5F5F5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M136.807 190.188H134.784V192.211H136.807V190.188Z",
    fill: "#F5F5F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M136.807 193.579H134.784V195.602H136.807V193.579Z",
    fill: "#F5F5F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M136.807 196.97H134.784V198.994H136.807V196.97Z",
    fill: "#F5F5F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M136.807 200.362H134.784V202.385H136.807V200.362Z",
    fill: "#F5F5F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M136.807 207.137H134.784V209.16H136.807V207.137Z",
    fill: "#F5F5F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M140.018 169.848H137.995V171.871H140.018V169.848Z",
    fill: "#F5F5F5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M140.018 173.239H137.995V175.262H140.018V173.239Z",
    fill: "#F5F5F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M140.018 176.63H137.995V178.654H140.018V176.63Z",
    fill: "#F5F5F5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M140.018 180.022H137.995V182.045H140.018V180.022Z",
    fill: "#F5F5F5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.018 183.406H137.995V185.429H140.018V183.406Z",
    fill: "#F5F5F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M140.018 186.797H137.995V188.82H140.018V186.797Z",
    fill: "#F5F5F5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M140.018 190.188H137.995V192.211H140.018V190.188Z",
    fill: "#F5F5F5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M140.018 220.702H137.995V222.725H140.018V220.702Z",
    fill: "#F5F5F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 169.848H141.206V171.871H143.229V169.848Z",
    fill: "#F5F5F5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 173.239H141.206V175.262H143.229V173.239Z",
    fill: "#F5F5F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 176.63H141.206V178.654H143.229V176.63Z",
    fill: "#F5F5F5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 180.022H141.206V182.045H143.229V180.022Z",
    fill: "#F5F5F5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 183.406H141.206V185.429H143.229V183.406Z",
    fill: "#F5F5F5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 186.797H141.206V188.82H143.229V186.797Z",
    fill: "#F5F5F5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 190.188H141.206V192.211H143.229V190.188Z",
    fill: "#F5F5F5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 193.579H141.206V195.602H143.229V193.579Z",
    fill: "#F5F5F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 213.919H141.206V215.942H143.229V213.919Z",
    fill: "#F5F5F5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 217.31H141.206V219.334H143.229V217.31Z",
    fill: "#F5F5F5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 220.702H141.206V222.725H143.229V220.702Z",
    fill: "#F5F5F5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 224.086H141.206V226.109H143.229V224.086Z",
    fill: "#F5F5F5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 237.65H141.206V239.674H143.229V237.65Z",
    fill: "#F5F5F5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 169.848H144.417V171.871H146.441V169.848Z",
    fill: "#F5F5F5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 173.239H144.417V175.262H146.441V173.239Z",
    fill: "#F5F5F5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 176.63H144.417V178.654H146.441V176.63Z",
    fill: "#F5F5F5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 180.022H144.417V182.045H146.441V180.022Z",
    fill: "#F5F5F5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 183.406H144.417V185.429H146.441V183.406Z",
    fill: "#F5F5F5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 186.797H144.417V188.82H146.441V186.797Z",
    fill: "#F5F5F5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 190.188H144.417V192.211H146.441V190.188Z",
    fill: "#F5F5F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 193.579H144.417V195.602H146.441V193.579Z",
    fill: "#F5F5F5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 196.97H144.417V198.994H146.441V196.97Z",
    fill: "#F5F5F5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 200.362H144.417V202.385H146.441V200.362Z",
    fill: "#F5F5F5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 210.528H144.417V212.551H146.441V210.528Z",
    fill: "#F5F5F5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 213.919H144.417V215.942H146.441V213.919Z",
    fill: "#F5F5F5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 217.31H144.417V219.334H146.441V217.31Z",
    fill: "#F5F5F5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 220.702H144.417V222.725H146.441V220.702Z",
    fill: "#F5F5F5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 224.086H144.417V226.109H146.441V224.086Z",
    fill: "#F5F5F5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M146.441 237.65H144.417V239.674H146.441V237.65Z",
    fill: "#F5F5F5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 169.848H147.636V171.871H149.659V169.848Z",
    fill: "#F5F5F5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 173.239H147.636V175.262H149.659V173.239Z",
    fill: "#F5F5F5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 176.63H147.636V178.654H149.659V176.63Z",
    fill: "#F5F5F5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 180.022H147.636V182.045H149.659V180.022Z",
    fill: "#F5F5F5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 183.406H147.636V185.429H149.659V183.406Z",
    fill: "#F5F5F5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 186.797H147.636V188.82H149.659V186.797Z",
    fill: "#F5F5F5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 190.188H147.636V192.211H149.659V190.188Z",
    fill: "#F5F5F5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 193.579H147.636V195.602H149.659V193.579Z",
    fill: "#F5F5F5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 196.97H147.636V198.994H149.659V196.97Z",
    fill: "#F5F5F5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 200.362H147.636V202.385H149.659V200.362Z",
    fill: "#F5F5F5"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 203.746H147.636V205.769H149.659V203.746Z",
    fill: "#F5F5F5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 207.137H147.636V209.16H149.659V207.137Z",
    fill: "#F5F5F5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 210.528H147.636V212.551H149.659V210.528Z",
    fill: "#F5F5F5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 213.919H147.636V215.942H149.659V213.919Z",
    fill: "#F5F5F5"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 217.31H147.636V219.334H149.659V217.31Z",
    fill: "#F5F5F5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 220.702H147.636V222.725H149.659V220.702Z",
    fill: "#F5F5F5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 224.086H147.636V226.109H149.659V224.086Z",
    fill: "#F5F5F5"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 227.477H147.636V229.5H149.659V227.477Z",
    fill: "#F5F5F5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 169.848H150.847V171.871H152.87V169.848Z",
    fill: "#F5F5F5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 173.239H150.847V175.262H152.87V173.239Z",
    fill: "#F5F5F5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 176.63H150.847V178.654H152.87V176.63Z",
    fill: "#F5F5F5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 180.022H150.847V182.045H152.87V180.022Z",
    fill: "#F5F5F5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 183.406H150.847V185.429H152.87V183.406Z",
    fill: "#F5F5F5"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 186.797H150.847V188.82H152.87V186.797Z",
    fill: "#F5F5F5"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 190.188H150.847V192.211H152.87V190.188Z",
    fill: "#F5F5F5"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 193.579H150.847V195.602H152.87V193.579Z",
    fill: "#F5F5F5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 196.97H150.847V198.994H152.87V196.97Z",
    fill: "#F5F5F5"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 200.362H150.847V202.385H152.87V200.362Z",
    fill: "#F5F5F5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 210.528H150.847V212.551H152.87V210.528Z",
    fill: "#F5F5F5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 213.919H150.847V215.942H152.87V213.919Z",
    fill: "#F5F5F5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 217.31H150.847V219.334H152.87V217.31Z",
    fill: "#F5F5F5"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 220.702H150.847V222.725H152.87V220.702Z",
    fill: "#F5F5F5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 169.848H154.058V171.871H156.082V169.848Z",
    fill: "#F5F5F5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 173.239H154.058V175.262H156.082V173.239Z",
    fill: "#F5F5F5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 176.63H154.058V178.654H156.082V176.63Z",
    fill: "#F5F5F5"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 180.022H154.058V182.045H156.082V180.022Z",
    fill: "#F5F5F5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 183.406H154.058V185.429H156.082V183.406Z",
    fill: "#F5F5F5"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 186.797H154.058V188.82H156.082V186.797Z",
    fill: "#F5F5F5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 190.188H154.058V192.211H156.082V190.188Z",
    fill: "#F5F5F5"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 193.579H154.058V195.602H156.082V193.579Z",
    fill: "#F5F5F5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 196.97H154.058V198.994H156.082V196.97Z",
    fill: "#F5F5F5"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 200.362H154.058V202.385H156.082V200.362Z",
    fill: "#F5F5F5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 210.528H154.058V212.551H156.082V210.528Z",
    fill: "#F5F5F5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 213.919H154.058V215.942H156.082V213.919Z",
    fill: "#F5F5F5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 217.31H154.058V219.334H156.082V217.31Z",
    fill: "#F5F5F5"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M192.24 161.042H190.217V163.066H192.24V161.042Z",
    fill: "#F5F5F5"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M192.24 164.434H190.217V166.457H192.24V164.434Z",
    fill: "#F5F5F5"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M192.24 167.825H190.217V169.848H192.24V167.825Z",
    fill: "#F5F5F5"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M192.24 171.216H190.217V173.239H192.24V171.216Z",
    fill: "#F5F5F5"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M192.24 174.607H190.217V176.63H192.24V174.607Z",
    fill: "#F5F5F5"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M192.24 177.998H190.217V180.022H192.24V177.998Z",
    fill: "#F5F5F5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M192.24 181.39H190.217V183.413H192.24V181.39Z",
    fill: "#F5F5F5"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M192.24 184.774H190.217V186.797H192.24V184.774Z",
    fill: "#F5F5F5"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M192.24 194.947H190.217V196.97H192.24V194.947Z",
    fill: "#F5F5F5"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M192.24 198.338H190.217V200.362H192.24V198.338Z",
    fill: "#F5F5F5"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M195.451 161.042H193.428V163.066H195.451V161.042Z",
    fill: "#F5F5F5"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M195.451 164.434H193.428V166.457H195.451V164.434Z",
    fill: "#F5F5F5"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M195.451 167.825H193.428V169.848H195.451V167.825Z",
    fill: "#F5F5F5"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M195.451 171.216H193.428V173.239H195.451V171.216Z",
    fill: "#F5F5F5"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M195.451 174.607H193.428V176.63H195.451V174.607Z",
    fill: "#F5F5F5"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M195.451 177.998H193.428V180.022H195.451V177.998Z",
    fill: "#F5F5F5"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M195.451 181.39H193.428V183.413H195.451V181.39Z",
    fill: "#F5F5F5"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M195.451 184.774H193.428V186.797H195.451V184.774Z",
    fill: "#F5F5F5"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M195.451 198.338H193.428V200.362H195.451V198.338Z",
    fill: "#F5F5F5"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M198.662 161.042H196.639V163.066H198.662V161.042Z",
    fill: "#F5F5F5"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M198.662 164.434H196.639V166.457H198.662V164.434Z",
    fill: "#F5F5F5"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M198.662 167.825H196.639V169.848H198.662V167.825Z",
    fill: "#F5F5F5"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M198.662 171.216H196.639V173.239H198.662V171.216Z",
    fill: "#F5F5F5"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M198.662 174.607H196.639V176.63H198.662V174.607Z",
    fill: "#F5F5F5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M198.662 177.998H196.639V180.022H198.662V177.998Z",
    fill: "#F5F5F5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M198.662 181.39H196.639V183.413H198.662V181.39Z",
    fill: "#F5F5F5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M198.662 184.774H196.639V186.797H198.662V184.774Z",
    fill: "#F5F5F5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 161.042H199.85V163.066H201.874V161.042Z",
    fill: "#F5F5F5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 164.434H199.85V166.457H201.874V164.434Z",
    fill: "#F5F5F5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 167.825H199.85V169.848H201.874V167.825Z",
    fill: "#F5F5F5"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 171.216H199.85V173.239H201.874V171.216Z",
    fill: "#F5F5F5"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 174.607H199.85V176.63H201.874V174.607Z",
    fill: "#F5F5F5"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 177.998H199.85V180.022H201.874V177.998Z",
    fill: "#F5F5F5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 184.774H199.85V186.797H201.874V184.774Z",
    fill: "#F5F5F5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 188.165H199.85V190.188H201.874V188.165Z",
    fill: "#F5F5F5"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 198.338H199.85V200.362H201.874V198.338Z",
    fill: "#F5F5F5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 201.73H199.85V203.753H201.874V201.73Z",
    fill: "#F5F5F5"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 205.114H199.85V207.137H201.874V205.114Z",
    fill: "#F5F5F5"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 208.505H199.85V210.528H201.874V208.505Z",
    fill: "#F5F5F5"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 211.896H199.85V213.919H201.874V211.896Z",
    fill: "#F5F5F5"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 215.287H199.85V217.31H201.874V215.287Z",
    fill: "#F5F5F5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 218.678H199.85V220.702H201.874V218.678Z",
    fill: "#F5F5F5"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 161.042H203.062V163.066H205.085V161.042Z",
    fill: "#F5F5F5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 164.434H203.062V166.457H205.085V164.434Z",
    fill: "#F5F5F5"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 167.825H203.062V169.848H205.085V167.825Z",
    fill: "#F5F5F5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 171.216H203.062V173.239H205.085V171.216Z",
    fill: "#F5F5F5"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 174.607H203.062V176.63H205.085V174.607Z",
    fill: "#F5F5F5"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 177.998H203.062V180.022H205.085V177.998Z",
    fill: "#F5F5F5"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 188.165H203.062V190.188H205.085V188.165Z",
    fill: "#F5F5F5"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 191.556H203.062V193.579H205.085V191.556Z",
    fill: "#F5F5F5"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 194.947H203.062V196.97H205.085V194.947Z",
    fill: "#F5F5F5"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 198.338H203.062V200.362H205.085V198.338Z",
    fill: "#F5F5F5"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 201.73H203.062V203.753H205.085V201.73Z",
    fill: "#F5F5F5"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 205.114H203.062V207.137H205.085V205.114Z",
    fill: "#F5F5F5"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 208.505H203.062V210.528H205.085V208.505Z",
    fill: "#F5F5F5"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 211.896H203.062V213.919H205.085V211.896Z",
    fill: "#F5F5F5"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 215.287H203.062V217.31H205.085V215.287Z",
    fill: "#F5F5F5"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 218.678H203.062V220.702H205.085V218.678Z",
    fill: "#F5F5F5"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 222.07H203.062V224.093H205.085V222.07Z",
    fill: "#F5F5F5"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M205.085 228.845H203.062V230.868H205.085V228.845Z",
    fill: "#F5F5F5"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 161.042H206.273V163.066H208.296V161.042Z",
    fill: "#F5F5F5"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 164.434H206.273V166.457H208.296V164.434Z",
    fill: "#F5F5F5"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 167.825H206.273V169.848H208.296V167.825Z",
    fill: "#F5F5F5"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 171.216H206.273V173.239H208.296V171.216Z",
    fill: "#F5F5F5"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 174.607H206.273V176.63H208.296V174.607Z",
    fill: "#F5F5F5"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 177.998H206.273V180.022H208.296V177.998Z",
    fill: "#F5F5F5"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 188.165H206.273V190.188H208.296V188.165Z",
    fill: "#F5F5F5"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 191.556H206.273V193.579H208.296V191.556Z",
    fill: "#F5F5F5"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 194.947H206.273V196.97H208.296V194.947Z",
    fill: "#F5F5F5"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 198.338H206.273V200.362H208.296V198.338Z",
    fill: "#F5F5F5"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 208.505H206.273V210.528H208.296V208.505Z",
    fill: "#F5F5F5"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 211.896H206.273V213.919H208.296V211.896Z",
    fill: "#F5F5F5"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 215.287H206.273V217.31H208.296V215.287Z",
    fill: "#F5F5F5"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 218.678H206.273V220.702H208.296V218.678Z",
    fill: "#F5F5F5"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 222.07H206.273V224.093H208.296V222.07Z",
    fill: "#F5F5F5"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 228.845H206.273V230.868H208.296V228.845Z",
    fill: "#F5F5F5"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M208.296 232.236H206.273V234.259H208.296V232.236Z",
    fill: "#F5F5F5"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M237.442 192.564H235.418V194.587H237.442V192.564Z",
    fill: "#F5F5F5"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M237.442 195.955H235.418V197.978H237.442V195.955Z",
    fill: "#F5F5F5"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M237.442 199.346H235.418V201.37H237.442V199.346Z",
    fill: "#F5F5F5"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M237.442 202.738H235.418V204.761H237.442V202.738Z",
    fill: "#F5F5F5"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M237.442 206.129H235.418V208.152H237.442V206.129Z",
    fill: "#F5F5F5"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M237.442 209.52H235.418V211.543H237.442V209.52Z",
    fill: "#F5F5F5"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M237.442 212.911H235.418V214.934H237.442V212.911Z",
    fill: "#F5F5F5"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M237.442 223.078H235.418V225.101H237.442V223.078Z",
    fill: "#F5F5F5"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M237.442 226.469H235.418V228.492H237.442V226.469Z",
    fill: "#F5F5F5"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M237.442 229.86H235.418V231.883H237.442V229.86Z",
    fill: "#F5F5F5"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M240.653 192.564H238.63V194.587H240.653V192.564Z",
    fill: "#F5F5F5"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M240.653 195.955H238.63V197.978H240.653V195.955Z",
    fill: "#F5F5F5"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M240.653 199.346H238.63V201.37H240.653V199.346Z",
    fill: "#F5F5F5"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M240.653 202.738H238.63V204.761H240.653V202.738Z",
    fill: "#F5F5F5"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M240.653 206.129H238.63V208.152H240.653V206.129Z",
    fill: "#F5F5F5"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M240.653 209.52H238.63V211.543H240.653V209.52Z",
    fill: "#F5F5F5"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M240.653 212.911H238.63V214.934H240.653V212.911Z",
    fill: "#F5F5F5"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M243.864 192.564H241.841V194.587H243.864V192.564Z",
    fill: "#F5F5F5"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M243.864 195.955H241.841V197.978H243.864V195.955Z",
    fill: "#F5F5F5"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M243.864 199.346H241.841V201.37H243.864V199.346Z",
    fill: "#F5F5F5"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M243.864 202.738H241.841V204.761H243.864V202.738Z",
    fill: "#F5F5F5"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M243.864 206.129H241.841V208.152H243.864V206.129Z",
    fill: "#F5F5F5"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M243.864 209.52H241.841V211.543H243.864V209.52Z",
    fill: "#F5F5F5"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M243.864 212.911H241.841V214.934H243.864V212.911Z",
    fill: "#F5F5F5"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M247.075 192.564H245.052V194.587H247.075V192.564Z",
    fill: "#F5F5F5"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M247.075 195.955H245.052V197.978H247.075V195.955Z",
    fill: "#F5F5F5"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M247.075 199.346H245.052V201.37H247.075V199.346Z",
    fill: "#F5F5F5"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M247.075 202.738H245.052V204.761H247.075V202.738Z",
    fill: "#F5F5F5"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M247.075 206.129H245.052V208.152H247.075V206.129Z",
    fill: "#F5F5F5"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M247.075 209.52H245.052V211.543H247.075V209.52Z",
    fill: "#F5F5F5"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M247.075 212.911H245.052V214.934H247.075V212.911Z",
    fill: "#F5F5F5"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M247.075 216.295H245.052V218.318H247.075V216.295Z",
    fill: "#F5F5F5"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M247.075 219.686H245.052V221.71H247.075V219.686Z",
    fill: "#F5F5F5"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M247.075 223.078H245.052V225.101H247.075V223.078Z",
    fill: "#F5F5F5"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M247.075 226.469H245.052V228.492H247.075V226.469Z",
    fill: "#F5F5F5"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 192.564H248.263V194.587H250.286V192.564Z",
    fill: "#F5F5F5"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 195.955H248.263V197.978H250.286V195.955Z",
    fill: "#F5F5F5"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 199.346H248.263V201.37H250.286V199.346Z",
    fill: "#F5F5F5"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 202.738H248.263V204.761H250.286V202.738Z",
    fill: "#F5F5F5"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 206.129H248.263V208.152H250.286V206.129Z",
    fill: "#F5F5F5"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 209.52H248.263V211.543H250.286V209.52Z",
    fill: "#F5F5F5"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 212.911H248.263V214.934H250.286V212.911Z",
    fill: "#F5F5F5"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 216.295H248.263V218.318H250.286V216.295Z",
    fill: "#F5F5F5"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 219.686H248.263V221.71H250.286V219.686Z",
    fill: "#F5F5F5"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 223.078H248.263V225.101H250.286V223.078Z",
    fill: "#F5F5F5"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 226.469H248.263V228.492H250.286V226.469Z",
    fill: "#F5F5F5"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 229.86H248.263V231.883H250.286V229.86Z",
    fill: "#F5F5F5"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 240.026H248.263V242.05H250.286V240.026Z",
    fill: "#F5F5F5"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M250.286 243.418H248.263V245.441H250.286V243.418Z",
    fill: "#F5F5F5"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 192.564H251.474V194.587H253.498V192.564Z",
    fill: "#F5F5F5"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 195.955H251.474V197.978H253.498V195.955Z",
    fill: "#F5F5F5"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 199.346H251.474V201.37H253.498V199.346Z",
    fill: "#F5F5F5"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 209.52H251.474V211.543H253.498V209.52Z",
    fill: "#F5F5F5"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 212.911H251.474V214.934H253.498V212.911Z",
    fill: "#F5F5F5"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 216.295H251.474V218.318H253.498V216.295Z",
    fill: "#F5F5F5"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 219.686H251.474V221.71H253.498V219.686Z",
    fill: "#F5F5F5"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 223.078H251.474V225.101H253.498V223.078Z",
    fill: "#F5F5F5"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 226.469H251.474V228.492H253.498V226.469Z",
    fill: "#F5F5F5"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 229.86H251.474V231.883H253.498V229.86Z",
    fill: "#F5F5F5"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 240.026H251.474V242.05H253.498V240.026Z",
    fill: "#F5F5F5"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 243.418H251.474V245.441H253.498V243.418Z",
    fill: "#F5F5F5"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M253.498 246.809H251.474V248.832H253.498V246.809Z",
    fill: "#F5F5F5"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 172.224H285.134V174.247H287.157V172.224Z",
    fill: "#F5F5F5"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 175.615H285.134V177.638H287.157V175.615Z",
    fill: "#F5F5F5"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 179.006H285.134V181.03H287.157V179.006Z",
    fill: "#F5F5F5"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 182.398H285.134V184.421H287.157V182.398Z",
    fill: "#F5F5F5"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 185.789H285.134V187.812H287.157V185.789Z",
    fill: "#F5F5F5"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 189.18H285.134V191.203H287.157V189.18Z",
    fill: "#F5F5F5"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 192.564H285.134V194.587H287.157V192.564Z",
    fill: "#F5F5F5"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 195.955H285.134V197.978H287.157V195.955Z",
    fill: "#F5F5F5"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 199.346H285.134V201.37H287.157V199.346Z",
    fill: "#F5F5F5"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 202.738H285.134V204.761H287.157V202.738Z",
    fill: "#F5F5F5"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 206.129H285.134V208.152H287.157V206.129Z",
    fill: "#F5F5F5"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 209.52H285.134V211.543H287.157V209.52Z",
    fill: "#F5F5F5"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 212.911H285.134V214.934H287.157V212.911Z",
    fill: "#F5F5F5"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 216.295H285.134V218.318H287.157V216.295Z",
    fill: "#F5F5F5"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 219.686H285.134V221.71H287.157V219.686Z",
    fill: "#F5F5F5"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 223.078H285.134V225.101H287.157V223.078Z",
    fill: "#F5F5F5"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 226.469H285.134V228.492H287.157V226.469Z",
    fill: "#F5F5F5"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 229.86H285.134V231.883H287.157V229.86Z",
    fill: "#F5F5F5"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 233.251H285.134V235.274H287.157V233.251Z",
    fill: "#F5F5F5"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 236.635H285.134V238.658H287.157V236.635Z",
    fill: "#F5F5F5"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 240.026H285.134V242.05H287.157V240.026Z",
    fill: "#F5F5F5"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 243.418H285.134V245.441H287.157V243.418Z",
    fill: "#F5F5F5"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 246.809H285.134V248.832H287.157V246.809Z",
    fill: "#F5F5F5"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 172.224H288.346V174.247H290.369V172.224Z",
    fill: "#F5F5F5"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 175.615H288.346V177.638H290.369V175.615Z",
    fill: "#F5F5F5"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 179.006H288.346V181.03H290.369V179.006Z",
    fill: "#F5F5F5"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 182.398H288.346V184.421H290.369V182.398Z",
    fill: "#F5F5F5"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 185.789H288.346V187.812H290.369V185.789Z",
    fill: "#F5F5F5"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 189.18H288.346V191.203H290.369V189.18Z",
    fill: "#F5F5F5"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 192.564H288.346V194.587H290.369V192.564Z",
    fill: "#F5F5F5"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 195.955H288.346V197.978H290.369V195.955Z",
    fill: "#F5F5F5"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 199.346H288.346V201.37H290.369V199.346Z",
    fill: "#F5F5F5"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 202.738H288.346V204.761H290.369V202.738Z",
    fill: "#F5F5F5"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 206.129H288.346V208.152H290.369V206.129Z",
    fill: "#F5F5F5"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 209.52H288.346V211.543H290.369V209.52Z",
    fill: "#F5F5F5"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 212.911H288.346V214.934H290.369V212.911Z",
    fill: "#F5F5F5"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 216.295H288.346V218.318H290.369V216.295Z",
    fill: "#F5F5F5"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 219.686H288.346V221.71H290.369V219.686Z",
    fill: "#F5F5F5"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 223.078H288.346V225.101H290.369V223.078Z",
    fill: "#F5F5F5"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 226.469H288.346V228.492H290.369V226.469Z",
    fill: "#F5F5F5"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 229.86H288.346V231.883H290.369V229.86Z",
    fill: "#F5F5F5"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 233.251H288.346V235.274H290.369V233.251Z",
    fill: "#F5F5F5"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 172.224H291.564V174.247H293.587V172.224Z",
    fill: "#F5F5F5"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 175.615H291.564V177.638H293.587V175.615Z",
    fill: "#F5F5F5"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 179.006H291.564V181.03H293.587V179.006Z",
    fill: "#F5F5F5"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 182.398H291.564V184.421H293.587V182.398Z",
    fill: "#F5F5F5"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 185.789H291.564V187.812H293.587V185.789Z",
    fill: "#F5F5F5"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 189.18H291.564V191.203H293.587V189.18Z",
    fill: "#F5F5F5"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 192.564H291.564V194.587H293.587V192.564Z",
    fill: "#F5F5F5"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 195.955H291.564V197.978H293.587V195.955Z",
    fill: "#F5F5F5"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 199.346H291.564V201.37H293.587V199.346Z",
    fill: "#F5F5F5"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 202.738H291.564V204.761H293.587V202.738Z",
    fill: "#F5F5F5"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 206.129H291.564V208.152H293.587V206.129Z",
    fill: "#F5F5F5"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 209.52H291.564V211.543H293.587V209.52Z",
    fill: "#F5F5F5"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 212.911H291.564V214.934H293.587V212.911Z",
    fill: "#F5F5F5"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 216.295H291.564V218.318H293.587V216.295Z",
    fill: "#F5F5F5"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 219.686H291.564V221.71H293.587V219.686Z",
    fill: "#F5F5F5"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 223.078H291.564V225.101H293.587V223.078Z",
    fill: "#F5F5F5"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 226.469H291.564V228.492H293.587V226.469Z",
    fill: "#F5F5F5"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 229.86H291.564V231.883H293.587V229.86Z",
    fill: "#F5F5F5"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M293.587 233.251H291.564V235.274H293.587V233.251Z",
    fill: "#F5F5F5"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 172.224H294.775V174.247H296.798V172.224Z",
    fill: "#F5F5F5"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 175.615H294.775V177.638H296.798V175.615Z",
    fill: "#F5F5F5"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 179.006H294.775V181.03H296.798V179.006Z",
    fill: "#F5F5F5"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 182.398H294.775V184.421H296.798V182.398Z",
    fill: "#F5F5F5"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 185.789H294.775V187.812H296.798V185.789Z",
    fill: "#F5F5F5"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 189.18H294.775V191.203H296.798V189.18Z",
    fill: "#F5F5F5"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 192.564H294.775V194.587H296.798V192.564Z",
    fill: "#F5F5F5"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 195.955H294.775V197.978H296.798V195.955Z",
    fill: "#F5F5F5"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 199.346H294.775V201.37H296.798V199.346Z",
    fill: "#F5F5F5"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 202.738H294.775V204.761H296.798V202.738Z",
    fill: "#F5F5F5"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 206.129H294.775V208.152H296.798V206.129Z",
    fill: "#F5F5F5"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 209.52H294.775V211.543H296.798V209.52Z",
    fill: "#F5F5F5"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 212.911H294.775V214.934H296.798V212.911Z",
    fill: "#F5F5F5"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 216.295H294.775V218.318H296.798V216.295Z",
    fill: "#F5F5F5"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M296.798 219.686H294.775V221.71H296.798V219.686Z",
    fill: "#F5F5F5"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 172.224H297.986V174.247H300.01V172.224Z",
    fill: "#F5F5F5"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 175.615H297.986V177.638H300.01V175.615Z",
    fill: "#F5F5F5"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 179.006H297.986V181.03H300.01V179.006Z",
    fill: "#F5F5F5"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 182.398H297.986V184.421H300.01V182.398Z",
    fill: "#F5F5F5"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 185.789H297.986V187.812H300.01V185.789Z",
    fill: "#F5F5F5"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 189.18H297.986V191.203H300.01V189.18Z",
    fill: "#F5F5F5"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 192.564H297.986V194.587H300.01V192.564Z",
    fill: "#F5F5F5"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 195.955H297.986V197.978H300.01V195.955Z",
    fill: "#F5F5F5"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 199.346H297.986V201.37H300.01V199.346Z",
    fill: "#F5F5F5"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 202.738H297.986V204.761H300.01V202.738Z",
    fill: "#F5F5F5"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 206.129H297.986V208.152H300.01V206.129Z",
    fill: "#F5F5F5"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 209.52H297.986V211.543H300.01V209.52Z",
    fill: "#F5F5F5"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 212.911H297.986V214.934H300.01V212.911Z",
    fill: "#F5F5F5"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M303.221 172.224H301.198V174.247H303.221V172.224Z",
    fill: "#F5F5F5"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M303.221 175.615H301.198V177.638H303.221V175.615Z",
    fill: "#F5F5F5"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M303.221 179.006H301.198V181.03H303.221V179.006Z",
    fill: "#F5F5F5"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M303.221 182.398H301.198V184.421H303.221V182.398Z",
    fill: "#F5F5F5"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M303.221 185.789H301.198V187.812H303.221V185.789Z",
    fill: "#F5F5F5"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M303.221 189.18H301.198V191.203H303.221V189.18Z",
    fill: "#F5F5F5"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M303.221 192.564H301.198V194.587H303.221V192.564Z",
    fill: "#F5F5F5"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M303.221 195.955H301.198V197.978H303.221V195.955Z",
    fill: "#F5F5F5"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M303.221 199.346H301.198V201.37H303.221V199.346Z",
    fill: "#F5F5F5"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M303.221 202.738H301.198V204.761H303.221V202.738Z",
    fill: "#F5F5F5"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M303.221 206.129H301.198V208.152H303.221V206.129Z",
    fill: "#F5F5F5"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M303.221 209.52H301.198V211.543H303.221V209.52Z",
    fill: "#F5F5F5"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 196.97H65.2031V198.994H67.2263V196.97Z",
    fill: "#F5F5F5"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 200.362H65.2031V202.385H67.2263V200.362Z",
    fill: "#F5F5F5"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 203.746H65.2031V205.769H67.2263V203.746Z",
    fill: "#F5F5F5"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 207.137H65.2031V209.16H67.2263V207.137Z",
    fill: "#F5F5F5"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 210.528H65.2031V212.551H67.2263V210.528Z",
    fill: "#F5F5F5"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 213.919H65.2031V215.942H67.2263V213.919Z",
    fill: "#F5F5F5"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 217.31H65.2031V219.334H67.2263V217.31Z",
    fill: "#F5F5F5"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 220.702H65.2031V222.725H67.2263V220.702Z",
    fill: "#F5F5F5"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 224.086H65.2031V226.109H67.2263V224.086Z",
    fill: "#F5F5F5"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 227.477H65.2031V229.5H67.2263V227.477Z",
    fill: "#F5F5F5"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 230.868H65.2031V232.891H67.2263V230.868Z",
    fill: "#F5F5F5"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 234.259H65.2031V236.282H67.2263V234.259Z",
    fill: "#F5F5F5"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 237.65H65.2031V239.674H67.2263V237.65Z",
    fill: "#F5F5F5"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 241.042H65.2031V243.065H67.2263V241.042Z",
    fill: "#F5F5F5"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 244.426H65.2031V246.449H67.2263V244.426Z",
    fill: "#F5F5F5"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 247.817H65.2031V249.84H67.2263V247.817Z",
    fill: "#F5F5F5"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 251.208H65.2031V253.231H67.2263V251.208Z",
    fill: "#F5F5F5"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 254.599H65.2031V256.622H67.2263V254.599Z",
    fill: "#F5F5F5"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 257.99H65.2031V260.014H67.2263V257.99Z",
    fill: "#F5F5F5"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2263 261.382H65.2031V263.405H67.2263V261.382Z",
    fill: "#F5F5F5"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 196.97H68.4143V198.994H70.4375V196.97Z",
    fill: "#F5F5F5"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 200.362H68.4143V202.385H70.4375V200.362Z",
    fill: "#F5F5F5"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 203.746H68.4143V205.769H70.4375V203.746Z",
    fill: "#F5F5F5"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 207.137H68.4143V209.16H70.4375V207.137Z",
    fill: "#F5F5F5"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 210.528H68.4143V212.551H70.4375V210.528Z",
    fill: "#F5F5F5"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 213.919H68.4143V215.942H70.4375V213.919Z",
    fill: "#F5F5F5"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 217.31H68.4143V219.334H70.4375V217.31Z",
    fill: "#F5F5F5"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 220.702H68.4143V222.725H70.4375V220.702Z",
    fill: "#F5F5F5"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 224.086H68.4143V226.109H70.4375V224.086Z",
    fill: "#F5F5F5"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 227.477H68.4143V229.5H70.4375V227.477Z",
    fill: "#F5F5F5"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 230.868H68.4143V232.891H70.4375V230.868Z",
    fill: "#F5F5F5"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 234.259H68.4143V236.282H70.4375V234.259Z",
    fill: "#F5F5F5"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 237.65H68.4143V239.674H70.4375V237.65Z",
    fill: "#F5F5F5"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 241.042H68.4143V243.065H70.4375V241.042Z",
    fill: "#F5F5F5"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 244.426H68.4143V246.449H70.4375V244.426Z",
    fill: "#F5F5F5"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 247.817H68.4143V249.84H70.4375V247.817Z",
    fill: "#F5F5F5"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 251.208H68.4143V253.231H70.4375V251.208Z",
    fill: "#F5F5F5"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 254.599H68.4143V256.622H70.4375V254.599Z",
    fill: "#F5F5F5"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 196.97H71.6255V198.994H73.6487V196.97Z",
    fill: "#F5F5F5"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 200.362H71.6255V202.385H73.6487V200.362Z",
    fill: "#F5F5F5"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 203.746H71.6255V205.769H73.6487V203.746Z",
    fill: "#F5F5F5"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 207.137H71.6255V209.16H73.6487V207.137Z",
    fill: "#F5F5F5"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 210.528H71.6255V212.551H73.6487V210.528Z",
    fill: "#F5F5F5"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 213.919H71.6255V215.942H73.6487V213.919Z",
    fill: "#F5F5F5"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 217.31H71.6255V219.334H73.6487V217.31Z",
    fill: "#F5F5F5"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 220.702H71.6255V222.725H73.6487V220.702Z",
    fill: "#F5F5F5"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 224.086H71.6255V226.109H73.6487V224.086Z",
    fill: "#F5F5F5"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 227.477H71.6255V229.5H73.6487V227.477Z",
    fill: "#F5F5F5"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 230.868H71.6255V232.891H73.6487V230.868Z",
    fill: "#F5F5F5"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 234.259H71.6255V236.282H73.6487V234.259Z",
    fill: "#F5F5F5"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 237.65H71.6255V239.674H73.6487V237.65Z",
    fill: "#F5F5F5"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 241.042H71.6255V243.065H73.6487V241.042Z",
    fill: "#F5F5F5"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 244.426H71.6255V246.449H73.6487V244.426Z",
    fill: "#F5F5F5"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 247.817H71.6255V249.84H73.6487V247.817Z",
    fill: "#F5F5F5"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 251.208H71.6255V253.231H73.6487V251.208Z",
    fill: "#F5F5F5"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6487 254.599H71.6255V256.622H73.6487V254.599Z",
    fill: "#F5F5F5"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 221.71H53.1865V223.733H55.2097V221.71Z",
    fill: "#F5F5F5"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 225.101H53.1865V227.124H55.2097V225.101Z",
    fill: "#F5F5F5"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 228.492H53.1865V230.515H55.2097V228.492Z",
    fill: "#F5F5F5"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 231.883H53.1865V233.906H55.2097V231.883Z",
    fill: "#F5F5F5"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 235.267H53.1865V237.29H55.2097V235.267Z",
    fill: "#F5F5F5"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 238.658H53.1865V240.682H55.2097V238.658Z",
    fill: "#F5F5F5"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 242.05H53.1865V244.073H55.2097V242.05Z",
    fill: "#F5F5F5"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 245.441H53.1865V247.464H55.2097V245.441Z",
    fill: "#F5F5F5"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 248.832H53.1865V250.855H55.2097V248.832Z",
    fill: "#F5F5F5"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 252.223H53.1865V254.246H55.2097V252.223Z",
    fill: "#F5F5F5"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 255.607H53.1865V257.63H55.2097V255.607Z",
    fill: "#F5F5F5"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 258.998H53.1865V261.022H55.2097V258.998Z",
    fill: "#F5F5F5"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2097 262.39H53.1865V264.413H55.2097V262.39Z",
    fill: "#F5F5F5"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 221.71H56.3977V223.733H58.4209V221.71Z",
    fill: "#F5F5F5"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 225.101H56.3977V227.124H58.4209V225.101Z",
    fill: "#F5F5F5"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 228.492H56.3977V230.515H58.4209V228.492Z",
    fill: "#F5F5F5"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 231.883H56.3977V233.906H58.4209V231.883Z",
    fill: "#F5F5F5"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 235.267H56.3977V237.29H58.4209V235.267Z",
    fill: "#F5F5F5"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 238.658H56.3977V240.682H58.4209V238.658Z",
    fill: "#F5F5F5"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 242.05H56.3977V244.073H58.4209V242.05Z",
    fill: "#F5F5F5"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 245.441H56.3977V247.464H58.4209V245.441Z",
    fill: "#F5F5F5"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 248.832H56.3977V250.855H58.4209V248.832Z",
    fill: "#F5F5F5"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 252.223H56.3977V254.246H58.4209V252.223Z",
    fill: "#F5F5F5"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 255.607H56.3977V257.63H58.4209V255.607Z",
    fill: "#F5F5F5"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 258.998H56.3977V261.022H58.4209V258.998Z",
    fill: "#F5F5F5"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4209 262.39H56.3977V264.413H58.4209V262.39Z",
    fill: "#F5F5F5"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 221.71H59.6089V223.733H61.6321V221.71Z",
    fill: "#F5F5F5"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 225.101H59.6089V227.124H61.6321V225.101Z",
    fill: "#F5F5F5"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 228.492H59.6089V230.515H61.6321V228.492Z",
    fill: "#F5F5F5"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 231.883H59.6089V233.906H61.6321V231.883Z",
    fill: "#F5F5F5"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 235.267H59.6089V237.29H61.6321V235.267Z",
    fill: "#F5F5F5"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 238.658H59.6089V240.682H61.6321V238.658Z",
    fill: "#F5F5F5"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 242.05H59.6089V244.073H61.6321V242.05Z",
    fill: "#F5F5F5"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 245.441H59.6089V247.464H61.6321V245.441Z",
    fill: "#F5F5F5"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 248.832H59.6089V250.855H61.6321V248.832Z",
    fill: "#F5F5F5"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 252.223H59.6089V254.246H61.6321V252.223Z",
    fill: "#F5F5F5"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 255.607H59.6089V257.63H61.6321V255.607Z",
    fill: "#F5F5F5"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 258.998H59.6089V261.022H61.6321V258.998Z",
    fill: "#F5F5F5"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 262.39H59.6089V264.413H61.6321V262.39Z",
    fill: "#F5F5F5"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6321 265.781H59.6089V267.804H61.6321V265.781Z",
    fill: "#F5F5F5"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4736 222.718H77.4504V224.741H79.4736V222.718Z",
    fill: "#F5F5F5"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4736 226.109H77.4504V228.132H79.4736V226.109Z",
    fill: "#F5F5F5"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4736 229.5H77.4504V231.523H79.4736V229.5Z",
    fill: "#F5F5F5"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4736 232.891H77.4504V234.914H79.4736V232.891Z",
    fill: "#F5F5F5"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4736 236.282H77.4504V238.306H79.4736V236.282Z",
    fill: "#F5F5F5"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4736 239.674H77.4504V241.697H79.4736V239.674Z",
    fill: "#F5F5F5"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4736 243.065H77.4504V245.088H79.4736V243.065Z",
    fill: "#F5F5F5"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4736 246.449H77.4504V248.472H79.4736V246.449Z",
    fill: "#F5F5F5"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4736 249.84H77.4504V251.863H79.4736V249.84Z",
    fill: "#F5F5F5"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4736 253.231H77.4504V255.254H79.4736V253.231Z",
    fill: "#F5F5F5"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4736 263.405H77.4504V265.428H79.4736V263.405Z",
    fill: "#F5F5F5"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6848 222.718H80.6616V224.741H82.6848V222.718Z",
    fill: "#F5F5F5"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6848 226.109H80.6616V228.132H82.6848V226.109Z",
    fill: "#F5F5F5"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6848 229.5H80.6616V231.523H82.6848V229.5Z",
    fill: "#F5F5F5"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6848 232.891H80.6616V234.914H82.6848V232.891Z",
    fill: "#F5F5F5"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6848 236.282H80.6616V238.306H82.6848V236.282Z",
    fill: "#F5F5F5"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6848 239.674H80.6616V241.697H82.6848V239.674Z",
    fill: "#F5F5F5"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6848 243.065H80.6616V245.088H82.6848V243.065Z",
    fill: "#F5F5F5"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6848 246.449H80.6616V248.472H82.6848V246.449Z",
    fill: "#F5F5F5"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6848 249.84H80.6616V251.863H82.6848V249.84Z",
    fill: "#F5F5F5"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6848 260.014H80.6616V262.037H82.6848V260.014Z",
    fill: "#F5F5F5"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6848 263.405H80.6616V265.428H82.6848V263.405Z",
    fill: "#F5F5F5"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M85.896 222.718H83.8728V224.741H85.896V222.718Z",
    fill: "#F5F5F5"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M85.896 226.109H83.8728V228.132H85.896V226.109Z",
    fill: "#F5F5F5"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M85.896 229.5H83.8728V231.523H85.896V229.5Z",
    fill: "#F5F5F5"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M85.896 232.891H83.8728V234.914H85.896V232.891Z",
    fill: "#F5F5F5"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M85.896 236.282H83.8728V238.306H85.896V236.282Z",
    fill: "#F5F5F5"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M85.896 239.674H83.8728V241.697H85.896V239.674Z",
    fill: "#F5F5F5"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M85.896 243.065H83.8728V245.088H85.896V243.065Z",
    fill: "#F5F5F5"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M85.896 246.449H83.8728V248.472H85.896V246.449Z",
    fill: "#F5F5F5"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M85.896 256.622H83.8728V258.646H85.896V256.622Z",
    fill: "#F5F5F5"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M85.896 260.014H83.8728V262.037H85.896V260.014Z",
    fill: "#F5F5F5"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M85.896 263.405H83.8728V265.428H85.896V263.405Z",
    fill: "#F5F5F5"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 171.216H113.731V173.239H115.754V171.216Z",
    fill: "#F5F5F5"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 174.607H113.731V176.63H115.754V174.607Z",
    fill: "#F5F5F5"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 177.998H113.731V180.022H115.754V177.998Z",
    fill: "#F5F5F5"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 181.39H113.731V183.413H115.754V181.39Z",
    fill: "#F5F5F5"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 184.774H113.731V186.797H115.754V184.774Z",
    fill: "#F5F5F5"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 188.165H113.731V190.188H115.754V188.165Z",
    fill: "#F5F5F5"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 191.556H113.731V193.579H115.754V191.556Z",
    fill: "#F5F5F5"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 194.947H113.731V196.97H115.754V194.947Z",
    fill: "#F5F5F5"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 198.338H113.731V200.362H115.754V198.338Z",
    fill: "#F5F5F5"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 201.73H113.731V203.753H115.754V201.73Z",
    fill: "#F5F5F5"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 205.114H113.731V207.137H115.754V205.114Z",
    fill: "#F5F5F5"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 208.505H113.731V210.528H115.754V208.505Z",
    fill: "#F5F5F5"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 211.896H113.731V213.919H115.754V211.896Z",
    fill: "#F5F5F5"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 215.287H113.731V217.31H115.754V215.287Z",
    fill: "#F5F5F5"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 218.678H113.731V220.702H115.754V218.678Z",
    fill: "#F5F5F5"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 222.07H113.731V224.093H115.754V222.07Z",
    fill: "#F5F5F5"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 225.454H113.731V227.477H115.754V225.454Z",
    fill: "#F5F5F5"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 232.236H113.731V234.259H115.754V232.236Z",
    fill: "#F5F5F5"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 235.627H113.731V237.65H115.754V235.627Z",
    fill: "#F5F5F5"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 239.018H113.731V241.042H115.754V239.018Z",
    fill: "#F5F5F5"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 242.41H113.731V244.433H115.754V242.41Z",
    fill: "#F5F5F5"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 245.794H113.731V247.817H115.754V245.794Z",
    fill: "#F5F5F5"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 171.216H116.942V173.239H118.966V171.216Z",
    fill: "#F5F5F5"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 174.607H116.942V176.63H118.966V174.607Z",
    fill: "#F5F5F5"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 177.998H116.942V180.022H118.966V177.998Z",
    fill: "#F5F5F5"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 181.39H116.942V183.413H118.966V181.39Z",
    fill: "#F5F5F5"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 184.774H116.942V186.797H118.966V184.774Z",
    fill: "#F5F5F5"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 188.165H116.942V190.188H118.966V188.165Z",
    fill: "#F5F5F5"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 191.556H116.942V193.579H118.966V191.556Z",
    fill: "#F5F5F5"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 194.947H116.942V196.97H118.966V194.947Z",
    fill: "#F5F5F5"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 198.338H116.942V200.362H118.966V198.338Z",
    fill: "#F5F5F5"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 201.73H116.942V203.753H118.966V201.73Z",
    fill: "#F5F5F5"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 205.114H116.942V207.137H118.966V205.114Z",
    fill: "#F5F5F5"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 208.505H116.942V210.528H118.966V208.505Z",
    fill: "#F5F5F5"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 211.896H116.942V213.919H118.966V211.896Z",
    fill: "#F5F5F5"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 215.287H116.942V217.31H118.966V215.287Z",
    fill: "#F5F5F5"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 218.678H116.942V220.702H118.966V218.678Z",
    fill: "#F5F5F5"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 222.07H116.942V224.093H118.966V222.07Z",
    fill: "#F5F5F5"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 242.41H116.942V244.433H118.966V242.41Z",
    fill: "#F5F5F5"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 245.794H116.942V247.817H118.966V245.794Z",
    fill: "#F5F5F5"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 171.216H120.154V173.239H122.177V171.216Z",
    fill: "#F5F5F5"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 174.607H120.154V176.63H122.177V174.607Z",
    fill: "#F5F5F5"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 177.998H120.154V180.022H122.177V177.998Z",
    fill: "#F5F5F5"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 181.39H120.154V183.413H122.177V181.39Z",
    fill: "#F5F5F5"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 184.774H120.154V186.797H122.177V184.774Z",
    fill: "#F5F5F5"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 188.165H120.154V190.188H122.177V188.165Z",
    fill: "#F5F5F5"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 191.556H120.154V193.579H122.177V191.556Z",
    fill: "#F5F5F5"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 194.947H120.154V196.97H122.177V194.947Z",
    fill: "#F5F5F5"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 198.338H120.154V200.362H122.177V198.338Z",
    fill: "#F5F5F5"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 201.73H120.154V203.753H122.177V201.73Z",
    fill: "#F5F5F5"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 205.114H120.154V207.137H122.177V205.114Z",
    fill: "#F5F5F5"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 208.505H120.154V210.528H122.177V208.505Z",
    fill: "#F5F5F5"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 211.896H120.154V213.919H122.177V211.896Z",
    fill: "#F5F5F5"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 215.287H120.154V217.31H122.177V215.287Z",
    fill: "#F5F5F5"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 218.678H120.154V220.702H122.177V218.678Z",
    fill: "#F5F5F5"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 222.07H120.154V224.093H122.177V222.07Z",
    fill: "#F5F5F5"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 228.845H120.154V230.868H122.177V228.845Z",
    fill: "#F5F5F5"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 232.236H120.154V234.259H122.177V232.236Z",
    fill: "#F5F5F5"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 235.627H120.154V237.65H122.177V235.627Z",
    fill: "#F5F5F5"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 239.018H120.154V241.042H122.177V239.018Z",
    fill: "#F5F5F5"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M122.177 245.794H120.154V247.817H122.177V245.794Z",
    fill: "#F5F5F5"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 213.919H102.074V215.942H104.098V213.919Z",
    fill: "#F5F5F5"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 217.31H102.074V219.334H104.098V217.31Z",
    fill: "#F5F5F5"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 220.702H102.074V222.725H104.098V220.702Z",
    fill: "#F5F5F5"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 224.086H102.074V226.109H104.098V224.086Z",
    fill: "#F5F5F5"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 227.477H102.074V229.5H104.098V227.477Z",
    fill: "#F5F5F5"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 230.868H102.074V232.891H104.098V230.868Z",
    fill: "#F5F5F5"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 234.259H102.074V236.282H104.098V234.259Z",
    fill: "#F5F5F5"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 241.042H102.074V243.065H104.098V241.042Z",
    fill: "#F5F5F5"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 244.426H102.074V246.449H104.098V244.426Z",
    fill: "#F5F5F5"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 247.817H102.074V249.84H104.098V247.817Z",
    fill: "#F5F5F5"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 251.208H102.074V253.231H104.098V251.208Z",
    fill: "#F5F5F5"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 254.599H102.074V256.622H104.098V254.599Z",
    fill: "#F5F5F5"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 257.99H102.074V260.014H104.098V257.99Z",
    fill: "#F5F5F5"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 261.382H102.074V263.405H104.098V261.382Z",
    fill: "#F5F5F5"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M104.098 264.773H102.074V266.796H104.098V264.773Z",
    fill: "#F5F5F5"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 213.919H105.286V215.942H107.309V213.919Z",
    fill: "#F5F5F5"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 217.31H105.286V219.334H107.309V217.31Z",
    fill: "#F5F5F5"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 220.702H105.286V222.725H107.309V220.702Z",
    fill: "#F5F5F5"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 224.086H105.286V226.109H107.309V224.086Z",
    fill: "#F5F5F5"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 227.477H105.286V229.5H107.309V227.477Z",
    fill: "#F5F5F5"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 230.868H105.286V232.891H107.309V230.868Z",
    fill: "#F5F5F5"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 241.042H105.286V243.065H107.309V241.042Z",
    fill: "#F5F5F5"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 244.426H105.286V246.449H107.309V244.426Z",
    fill: "#F5F5F5"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 247.817H105.286V249.84H107.309V247.817Z",
    fill: "#F5F5F5"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 251.208H105.286V253.231H107.309V251.208Z",
    fill: "#F5F5F5"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 254.599H105.286V256.622H107.309V254.599Z",
    fill: "#F5F5F5"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 257.99H105.286V260.014H107.309V257.99Z",
    fill: "#F5F5F5"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 261.382H105.286V263.405H107.309V261.382Z",
    fill: "#F5F5F5"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 264.773H105.286V266.796H107.309V264.773Z",
    fill: "#F5F5F5"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 213.919H108.497V215.942H110.52V213.919Z",
    fill: "#F5F5F5"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 217.31H108.497V219.334H110.52V217.31Z",
    fill: "#F5F5F5"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 220.702H108.497V222.725H110.52V220.702Z",
    fill: "#F5F5F5"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 224.086H108.497V226.109H110.52V224.086Z",
    fill: "#F5F5F5"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 227.477H108.497V229.5H110.52V227.477Z",
    fill: "#F5F5F5"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 230.868H108.497V232.891H110.52V230.868Z",
    fill: "#F5F5F5"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 237.65H108.497V239.674H110.52V237.65Z",
    fill: "#F5F5F5"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 241.042H108.497V243.065H110.52V241.042Z",
    fill: "#F5F5F5"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 244.426H108.497V246.449H110.52V244.426Z",
    fill: "#F5F5F5"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 247.817H108.497V249.84H110.52V247.817Z",
    fill: "#F5F5F5"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 251.208H108.497V253.231H110.52V251.208Z",
    fill: "#F5F5F5"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 254.599H108.497V256.622H110.52V254.599Z",
    fill: "#F5F5F5"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 257.99H108.497V260.014H110.52V257.99Z",
    fill: "#F5F5F5"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 261.382H108.497V263.405H110.52V261.382Z",
    fill: "#F5F5F5"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 264.773H108.497V266.796H110.52V264.773Z",
    fill: "#F5F5F5"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 194.947H176.177V196.97H178.2V194.947Z",
    fill: "#F5F5F5"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 198.338H176.177V200.362H178.2V198.338Z",
    fill: "#F5F5F5"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 201.73H176.177V203.753H178.2V201.73Z",
    fill: "#F5F5F5"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 205.114H176.177V207.137H178.2V205.114Z",
    fill: "#F5F5F5"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 208.505H176.177V210.528H178.2V208.505Z",
    fill: "#F5F5F5"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 211.896H176.177V213.919H178.2V211.896Z",
    fill: "#F5F5F5"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 215.287H176.177V217.31H178.2V215.287Z",
    fill: "#F5F5F5"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 218.678H176.177V220.702H178.2V218.678Z",
    fill: "#F5F5F5"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 222.07H176.177V224.093H178.2V222.07Z",
    fill: "#F5F5F5"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 225.454H176.177V227.477H178.2V225.454Z",
    fill: "#F5F5F5"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 228.845H176.177V230.868H178.2V228.845Z",
    fill: "#F5F5F5"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 232.236H176.177V234.259H178.2V232.236Z",
    fill: "#F5F5F5"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 235.627H176.177V237.65H178.2V235.627Z",
    fill: "#F5F5F5"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 242.41H176.177V244.433H178.2V242.41Z",
    fill: "#F5F5F5"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 245.794H176.177V247.817H178.2V245.794Z",
    fill: "#F5F5F5"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 249.185H176.177V251.208H178.2V249.185Z",
    fill: "#F5F5F5"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 252.576H176.177V254.599H178.2V252.576Z",
    fill: "#F5F5F5"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 259.358H176.177V261.382H178.2V259.358Z",
    fill: "#F5F5F5"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 262.75H176.177V264.773H178.2V262.75Z",
    fill: "#F5F5F5"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M178.2 266.141H176.177V268.164H178.2V266.141Z",
    fill: "#F5F5F5"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 194.947H179.395V196.97H181.418V194.947Z",
    fill: "#F5F5F5"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 198.338H179.395V200.362H181.418V198.338Z",
    fill: "#F5F5F5"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 201.73H179.395V203.753H181.418V201.73Z",
    fill: "#F5F5F5"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 205.114H179.395V207.137H181.418V205.114Z",
    fill: "#F5F5F5"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 208.505H179.395V210.528H181.418V208.505Z",
    fill: "#F5F5F5"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 211.896H179.395V213.919H181.418V211.896Z",
    fill: "#F5F5F5"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 215.287H179.395V217.31H181.418V215.287Z",
    fill: "#F5F5F5"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 218.678H179.395V220.702H181.418V218.678Z",
    fill: "#F5F5F5"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 222.07H179.395V224.093H181.418V222.07Z",
    fill: "#F5F5F5"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 225.454H179.395V227.477H181.418V225.454Z",
    fill: "#F5F5F5"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 228.845H179.395V230.868H181.418V228.845Z",
    fill: "#F5F5F5"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 232.236H179.395V234.259H181.418V232.236Z",
    fill: "#F5F5F5"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 235.627H179.395V237.65H181.418V235.627Z",
    fill: "#F5F5F5"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 245.794H179.395V247.817H181.418V245.794Z",
    fill: "#F5F5F5"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 249.185H179.395V251.208H181.418V249.185Z",
    fill: "#F5F5F5"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 255.967H179.395V257.99H181.418V255.967Z",
    fill: "#F5F5F5"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 259.358H179.395V261.382H181.418V259.358Z",
    fill: "#F5F5F5"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 262.75H179.395V264.773H181.418V262.75Z",
    fill: "#F5F5F5"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M181.418 266.141H179.395V268.164H181.418V266.141Z",
    fill: "#F5F5F5"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 194.947H182.606V196.97H184.63V194.947Z",
    fill: "#F5F5F5"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 198.338H182.606V200.362H184.63V198.338Z",
    fill: "#F5F5F5"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 201.73H182.606V203.753H184.63V201.73Z",
    fill: "#F5F5F5"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 205.114H182.606V207.137H184.63V205.114Z",
    fill: "#F5F5F5"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 208.505H182.606V210.528H184.63V208.505Z",
    fill: "#F5F5F5"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 211.896H182.606V213.919H184.63V211.896Z",
    fill: "#F5F5F5"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 215.287H182.606V217.31H184.63V215.287Z",
    fill: "#F5F5F5"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 218.678H182.606V220.702H184.63V218.678Z",
    fill: "#F5F5F5"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 222.07H182.606V224.093H184.63V222.07Z",
    fill: "#F5F5F5"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 225.454H182.606V227.477H184.63V225.454Z",
    fill: "#F5F5F5"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 228.845H182.606V230.868H184.63V228.845Z",
    fill: "#F5F5F5"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 232.236H182.606V234.259H184.63V232.236Z",
    fill: "#F5F5F5"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 235.627H182.606V237.65H184.63V235.627Z",
    fill: "#F5F5F5"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 239.018H182.606V241.042H184.63V239.018Z",
    fill: "#F5F5F5"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 245.794H182.606V247.817H184.63V245.794Z",
    fill: "#F5F5F5"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 252.576H182.606V254.599H184.63V252.576Z",
    fill: "#F5F5F5"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 255.967H182.606V257.99H184.63V255.967Z",
    fill: "#F5F5F5"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 259.358H182.606V261.382H184.63V259.358Z",
    fill: "#F5F5F5"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 262.75H182.606V264.773H184.63V262.75Z",
    fill: "#F5F5F5"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M184.63 266.141H182.606V268.164H184.63V266.141Z",
    fill: "#F5F5F5"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 214.279H163.094V216.302H165.118V214.279Z",
    fill: "#F5F5F5"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 217.663H163.094V219.686H165.118V217.663Z",
    fill: "#F5F5F5"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 221.054H163.094V223.078H165.118V221.054Z",
    fill: "#F5F5F5"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 224.446H163.094V226.469H165.118V224.446Z",
    fill: "#F5F5F5"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 227.837H163.094V229.86H165.118V227.837Z",
    fill: "#F5F5F5"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 231.228H163.094V233.251H165.118V231.228Z",
    fill: "#F5F5F5"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 241.394H163.094V243.418H165.118V241.394Z",
    fill: "#F5F5F5"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 244.786H163.094V246.809H165.118V244.786Z",
    fill: "#F5F5F5"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 248.177H163.094V250.2H165.118V248.177Z",
    fill: "#F5F5F5"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 251.568H163.094V253.591H165.118V251.568Z",
    fill: "#F5F5F5"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 254.959H163.094V256.982H165.118V254.959Z",
    fill: "#F5F5F5"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 258.343H163.094V260.366H165.118V258.343Z",
    fill: "#F5F5F5"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M165.118 261.734H163.094V263.758H165.118V261.734Z",
    fill: "#F5F5F5"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 214.279H166.306V216.302H168.329V214.279Z",
    fill: "#F5F5F5"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 217.663H166.306V219.686H168.329V217.663Z",
    fill: "#F5F5F5"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 221.054H166.306V223.078H168.329V221.054Z",
    fill: "#F5F5F5"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 224.446H166.306V226.469H168.329V224.446Z",
    fill: "#F5F5F5"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 227.837H166.306V229.86H168.329V227.837Z",
    fill: "#F5F5F5"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 231.228H166.306V233.251H168.329V231.228Z",
    fill: "#F5F5F5"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 241.394H166.306V243.418H168.329V241.394Z",
    fill: "#F5F5F5"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 244.786H166.306V246.809H168.329V244.786Z",
    fill: "#F5F5F5"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 248.177H166.306V250.2H168.329V248.177Z",
    fill: "#F5F5F5"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 251.568H166.306V253.591H168.329V251.568Z",
    fill: "#F5F5F5"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 254.959H166.306V256.982H168.329V254.959Z",
    fill: "#F5F5F5"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 258.343H166.306V260.366H168.329V258.343Z",
    fill: "#F5F5F5"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M168.329 265.126H166.306V267.149H168.329V265.126Z",
    fill: "#F5F5F5"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 199.346H273.002V201.37H275.026V199.346Z",
    fill: "#F5F5F5"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 202.738H273.002V204.761H275.026V202.738Z",
    fill: "#F5F5F5"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 206.129H273.002V208.152H275.026V206.129Z",
    fill: "#F5F5F5"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 209.52H273.002V211.543H275.026V209.52Z",
    fill: "#F5F5F5"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 212.911H273.002V214.934H275.026V212.911Z",
    fill: "#F5F5F5"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 216.295H273.002V218.318H275.026V216.295Z",
    fill: "#F5F5F5"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 219.686H273.002V221.71H275.026V219.686Z",
    fill: "#F5F5F5"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 223.078H273.002V225.101H275.026V223.078Z",
    fill: "#F5F5F5"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 226.469H273.002V228.492H275.026V226.469Z",
    fill: "#F5F5F5"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 229.86H273.002V231.883H275.026V229.86Z",
    fill: "#F5F5F5"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 233.251H273.002V235.274H275.026V233.251Z",
    fill: "#F5F5F5"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 240.026H273.002V242.05H275.026V240.026Z",
    fill: "#F5F5F5"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 243.418H273.002V245.441H275.026V243.418Z",
    fill: "#F5F5F5"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 246.809H273.002V248.832H275.026V246.809Z",
    fill: "#F5F5F5"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 250.2H273.002V252.223H275.026V250.2Z",
    fill: "#F5F5F5"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 253.591H273.002V255.614H275.026V253.591Z",
    fill: "#F5F5F5"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 256.975H273.002V258.998H275.026V256.975Z",
    fill: "#F5F5F5"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 260.366H273.002V262.39H275.026V260.366Z",
    fill: "#F5F5F5"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M275.026 263.758H273.002V265.781H275.026V263.758Z",
    fill: "#F5F5F5"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 199.346H276.214V201.37H278.237V199.346Z",
    fill: "#F5F5F5"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 202.738H276.214V204.761H278.237V202.738Z",
    fill: "#F5F5F5"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 206.129H276.214V208.152H278.237V206.129Z",
    fill: "#F5F5F5"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 209.52H276.214V211.543H278.237V209.52Z",
    fill: "#F5F5F5"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 212.911H276.214V214.934H278.237V212.911Z",
    fill: "#F5F5F5"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 216.295H276.214V218.318H278.237V216.295Z",
    fill: "#F5F5F5"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 219.686H276.214V221.71H278.237V219.686Z",
    fill: "#F5F5F5"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 223.078H276.214V225.101H278.237V223.078Z",
    fill: "#F5F5F5"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 226.469H276.214V228.492H278.237V226.469Z",
    fill: "#F5F5F5"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 229.86H276.214V231.883H278.237V229.86Z",
    fill: "#F5F5F5"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 233.251H276.214V235.274H278.237V233.251Z",
    fill: "#F5F5F5"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 236.635H276.214V238.658H278.237V236.635Z",
    fill: "#F5F5F5"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 240.026H276.214V242.05H278.237V240.026Z",
    fill: "#F5F5F5"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 243.418H276.214V245.441H278.237V243.418Z",
    fill: "#F5F5F5"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 246.809H276.214V248.832H278.237V246.809Z",
    fill: "#F5F5F5"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 250.2H276.214V252.223H278.237V250.2Z",
    fill: "#F5F5F5"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 253.591H276.214V255.614H278.237V253.591Z",
    fill: "#F5F5F5"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 256.975H276.214V258.998H278.237V256.975Z",
    fill: "#F5F5F5"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 260.366H276.214V262.39H278.237V260.366Z",
    fill: "#F5F5F5"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M278.237 263.758H276.214V265.781H278.237V263.758Z",
    fill: "#F5F5F5"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M259.207 212.551H257.184V214.574H259.207V212.551Z",
    fill: "#F5F5F5"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M259.207 215.942H257.184V217.966H259.207V215.942Z",
    fill: "#F5F5F5"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M259.207 219.334H257.184V221.357H259.207V219.334Z",
    fill: "#F5F5F5"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M259.207 222.718H257.184V224.741H259.207V222.718Z",
    fill: "#F5F5F5"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M259.207 226.109H257.184V228.132H259.207V226.109Z",
    fill: "#F5F5F5"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M259.207 229.5H257.184V231.523H259.207V229.5Z",
    fill: "#F5F5F5"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M259.207 232.891H257.184V234.914H259.207V232.891Z",
    fill: "#F5F5F5"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M259.207 236.282H257.184V238.306H259.207V236.282Z",
    fill: "#F5F5F5"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M259.207 239.674H257.184V241.697H259.207V239.674Z",
    fill: "#F5F5F5"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M259.207 243.065H257.184V245.088H259.207V243.065Z",
    fill: "#F5F5F5"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M262.418 212.551H260.395V214.574H262.418V212.551Z",
    fill: "#F5F5F5"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M262.418 215.942H260.395V217.966H262.418V215.942Z",
    fill: "#F5F5F5"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M262.418 219.334H260.395V221.357H262.418V219.334Z",
    fill: "#F5F5F5"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M262.418 222.718H260.395V224.741H262.418V222.718Z",
    fill: "#F5F5F5"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M262.418 226.109H260.395V228.132H262.418V226.109Z",
    fill: "#F5F5F5"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M262.418 229.5H260.395V231.523H262.418V229.5Z",
    fill: "#F5F5F5"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M262.418 232.891H260.395V234.914H262.418V232.891Z",
    fill: "#F5F5F5"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M262.418 236.282H260.395V238.306H262.418V236.282Z",
    fill: "#F5F5F5"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M262.418 239.674H260.395V241.697H262.418V239.674Z",
    fill: "#F5F5F5"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M180 307.843C257.099 307.843 319.601 304.194 319.601 299.693C319.601 295.192 257.099 291.542 180 291.542C102.901 291.542 40.3992 295.192 40.3992 299.693C40.3992 304.194 102.901 307.843 180 307.843Z",
    fill: "#F5F5F5"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M301.86 294.444L292.385 247.241H288.749L279.274 294.444L272.304 298.706V299.974H308.599V298.706L301.86 294.444Z",
    fill: "#E31837"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M308.599 298.706H272.304V300.298H308.599V298.706Z",
    fill: "white"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.385 247.241H288.749L279.158 294.307H301.745L292.385 247.241Z",
    fill: "white"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M298.706 279.036L296.554 268.2H284.479L282.269 279.036H298.706Z",
    fill: "white"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5913 294.444L73.1161 247.241H69.4801L60.0049 294.444L53.0425 298.706V299.974H89.3305V298.706L82.5913 294.444Z",
    fill: "#E31837"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.3377 298.706H53.0425V300.298H89.3377V298.706Z",
    fill: "white"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.116 247.241H69.48L59.8896 294.307H82.4832L73.116 247.241Z",
    fill: "white"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M79.4377 279.036L77.2849 268.2H65.2105L63.0073 279.036H79.4377Z",
    fill: "white"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M260.762 294.523L266.817 294.624C266.916 294.625 267.011 294.66 267.087 294.723C267.163 294.786 267.215 294.873 267.235 294.97L268.149 299.419C268.17 299.514 268.172 299.613 268.153 299.709C268.135 299.804 268.097 299.895 268.043 299.976C267.988 300.057 267.918 300.126 267.836 300.179C267.754 300.231 267.662 300.267 267.566 300.283C267.514 300.29 267.46 300.29 267.408 300.283C265.449 300.218 264.024 300.082 261.561 300.038C260.049 300.038 255.477 300.103 253.389 300.038C251.301 299.974 251.057 297.936 251.913 297.763C255.765 296.986 258.674 295.87 259.92 294.79C260.157 294.598 260.458 294.503 260.762 294.523Z",
    fill: "#263238"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M209.736 294.523L215.791 294.624C215.89 294.625 215.985 294.66 216.061 294.723C216.137 294.786 216.189 294.873 216.209 294.97L217.116 299.419C217.137 299.514 217.138 299.612 217.121 299.707C217.103 299.802 217.066 299.893 217.012 299.974C216.958 300.055 216.889 300.124 216.808 300.177C216.726 300.23 216.635 300.266 216.54 300.283C216.485 300.29 216.429 300.29 216.374 300.283C214.416 300.218 212.998 300.082 210.535 300.038C209.023 300.038 204.451 300.103 202.356 300.038C200.261 299.974 200.03 297.936 200.916 297.763C204.768 296.986 207.677 295.87 208.922 294.79C209.152 294.605 209.441 294.51 209.736 294.523Z",
    fill: "#263238"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M268.171 294.833H259.92C259.92 294.833 249.422 260.23 248.522 251.402C247.622 242.575 247.291 220.442 247.291 220.442V220.486C246.938 220.961 243.821 225.338 240.235 230.429C235.548 237.089 230.047 244.966 228.888 246.895C225.49 252.583 217.166 294.804 217.166 294.804H208.894C208.894 294.804 210.96 257.04 215.201 244.584C219.442 232.128 237.737 204.926 238.529 203.465C239.544 201.6 242.035 195.682 242.035 195.682L266.738 199.116C266.738 199.116 267.142 203.299 267.113 206.957C266.998 220.68 264.406 239.227 263.988 244.217C263.21 253.699 268.171 294.833 268.171 294.833Z",
    fill: "#E31837"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M247.867 155.808C247.867 155.808 240.473 168.991 242.042 195.682L266.738 199.116C267.458 195.35 267.624 176.522 273.773 159.163C271.125 158.257 268.422 157.521 265.68 156.96C262.212 156.276 258.707 155.796 255.182 155.52C252.74 155.426 250.294 155.522 247.867 155.808Z",
    fill: "#263238"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M242.035 195.682L266.738 199.116C267.178 196.762 267.415 188.496 269.035 178.38C269.467 175.68 270 172.843 270.67 169.963C271.502 166.308 272.538 162.702 273.773 159.163C271.126 158.254 268.423 157.518 265.68 156.96C262.209 156.277 258.702 155.796 255.175 155.52C252.745 155.434 250.311 155.533 247.896 155.815C247.896 155.815 240.48 168.991 242.035 195.682Z",
    fill: "white"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M263.016 143.863C262.512 147.305 262.145 153.576 264.636 155.736C261.439 157.284 259.128 158.328 256.486 160.949C255.398 158.904 254.052 156.247 254.052 156.247C257.803 155.16 257.573 152.345 256.781 149.724L263.016 143.863Z",
    fill: "#E4897B"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.474 146.254L256.788 149.76C256.978 150.369 257.118 150.993 257.205 151.625C258.645 151.344 260.561 149.652 260.64 148.126C260.703 147.497 260.646 146.862 260.474 146.254Z",
    fill: "black"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M268.171 294.833H259.92C259.92 294.833 249.422 260.23 248.522 251.402C247.622 242.575 247.291 220.442 247.291 220.442V220.486C246.938 220.961 243.821 225.338 240.235 230.429C235.548 237.089 230.047 244.966 228.888 246.895C225.49 252.583 217.166 294.804 217.166 294.804H208.894C208.894 294.804 210.96 257.04 215.201 244.584C219.442 232.128 237.737 204.926 238.529 203.465C239.544 201.6 242.035 195.682 242.035 195.682L266.738 199.116C266.738 199.116 267.142 203.299 267.113 206.957C266.998 220.68 264.406 239.227 263.988 244.217C263.21 253.699 268.171 294.833 268.171 294.833Z",
    fill: "white"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M268.733 157.666L266.681 155.102L260.035 156.384L256.658 160.25L256.233 155.786L254.988 154.289L252.259 155.47V158.263L254.203 157.637L255.881 161.532L261.194 159.35L262.375 160.855L268.733 157.666Z",
    fill: "#263238"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M268.733 157.666L266.681 155.102L260.035 156.384L256.658 160.25L256.233 155.786L254.988 154.289L252.259 155.47V158.263L254.203 157.637L255.881 161.532L261.194 159.35L262.375 160.855L268.733 157.666Z",
    fill: "white"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M250.884 162.418C244.034 162.381 237.192 161.915 230.4 161.021C224.474 159.437 219.161 151.322 216.245 146.268L219.01 144.338C222.61 148.068 226.166 152.309 230.717 154.75C231.047 154.908 231.403 155.006 231.768 155.038C238.09 155.311 244.67 155.326 251.035 155.614L250.862 162.418H250.884Z",
    fill: "#DC897C"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M253.613 165.312C250.013 167.962 236.009 164.016 236.009 164.016L237.751 155.434C241.709 154.995 245.707 155.067 249.646 155.65C255.6 156.701 257.594 162.367 253.613 165.312Z",
    fill: "#263238"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M253.613 165.312C250.013 167.962 236.009 164.016 236.009 164.016L237.751 155.434C241.709 154.995 245.707 155.067 249.646 155.65C255.6 156.701 257.594 162.367 253.613 165.312Z",
    fill: "white"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M253.145 165.6C253.44 163.598 252.144 161.849 248.249 160.891C244.461 160.106 240.572 159.928 236.729 160.366L236.009 164.016C236.009 164.016 249.005 167.76 253.145 165.6Z",
    fill: "black"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M221.04 147.11L218.326 141.034L213.466 144.223C213.466 144.223 214.762 148.73 218.621 149.083L221.04 147.11Z",
    fill: "#E4897B"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M214.603 138.125L211.543 141.365L213.473 144.223L218.333 141.034L214.603 138.125Z",
    fill: "#E4897B"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M255.881 161.532L255.24 156.866L252.259 158.263L254.203 157.637L255.881 161.532Z",
    fill: "black"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M255.881 161.532L260.806 157.91L262.375 160.855L261.194 159.35L255.881 161.532Z",
    fill: "black"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M269.035 178.38C269.467 175.68 270 172.843 270.67 169.963C269.873 168.975 268.74 168.314 267.487 168.106C267.487 168.106 266.81 174.643 269.035 178.38Z",
    fill: "black"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M247.291 220.457V220.5C246.938 220.975 243.821 225.353 240.235 230.443C239.882 227.684 240.353 224.881 241.589 222.389C242.825 219.897 244.772 217.827 247.183 216.439L247.291 220.457Z",
    fill: "black"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M263.75 163.044L256.133 165.002L253.44 154.534L235.26 159.228L232.56 162.482L241.747 127.274L221.933 132.386L216.893 136.26L203.436 184.615L207.223 199.296L236.945 191.628L239.976 203.371L258.696 198.533L263.736 194.659L261.324 185.299L263.268 184.802L268.308 180.929L263.75 163.044ZM232.279 171.158L230.177 171.706L231.307 167.386L232.279 171.158Z",
    fill: "#E31837"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M235.159 128.981L221.954 132.386L235.159 128.981Z",
    fill: "black"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.96 169.697L235.253 159.228L232.582 162.482L236.686 146.758L231.199 167.782L231.307 167.378L232.279 171.158L230.177 171.706L237.96 169.697Z",
    fill: "black"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M245.038 199.498L242.006 187.754L212.285 195.422L208.49 180.742L221.954 132.386L216.9 136.26L203.443 184.615L207.23 199.296L236.952 191.628L239.983 203.371L258.732 198.533L263.786 194.659L245.038 199.498Z",
    fill: "black"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.373 180.95L260.755 182.916L262.778 190.75L261.374 185.321L263.318 184.824L268.373 180.95L266.062 171.994L268.373 180.95Z",
    fill: "black"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M276.631 163.274C277.279 166.284 277.769 169.236 278.143 172.274C278.532 176.155 279.108 180.425 278.222 184.514C275.774 191.995 264.982 187.632 260.222 185.285L261.36 182.16C264.787 182.743 268.207 183.442 271.498 183.103C271.881 183.08 272.254 182.967 272.585 182.772C272.642 182.729 272.585 182.714 272.47 182.772C272.365 182.863 272.281 182.976 272.225 183.103C272.225 182.974 272.268 182.671 272.282 182.383C272.282 176.486 270.914 170.438 269.942 164.614L276.61 163.246L276.631 163.274Z",
    fill: "#DC897C"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M273.773 159.163C280.404 161.95 279.979 177.768 279.979 177.768L270.95 178.402C269.235 174.46 267.834 170.389 266.76 166.226C265.406 160.344 269.359 157.32 273.773 159.163Z",
    fill: "#263238"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M273.773 159.163C280.404 161.95 279.979 177.768 279.979 177.768L270.95 178.402C269.235 174.46 267.834 170.389 266.76 166.226C265.406 160.344 269.359 157.32 273.773 159.163Z",
    fill: "white"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M263.232 182.592L258.149 178.272L255.154 183.262C255.154 183.262 258.278 186.761 261.907 185.422L263.232 182.592Z",
    fill: "#E4897B"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M253.526 177.293L252.18 181.541L255.154 183.283L258.149 178.294L253.526 177.293Z",
    fill: "#E4897B"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M252.439 132.854C250.222 134.114 249.523 140.774 252.598 141.89C255.672 143.006 256.644 130.478 252.439 132.854Z",
    fill: "#263238"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M263.65 138.96C263.066 143.618 262.966 146.369 260.453 148.702C259.646 149.467 258.645 149.998 257.558 150.236C256.471 150.474 255.34 150.41 254.287 150.051C253.234 149.692 252.299 149.052 251.584 148.2C250.869 147.348 250.4 146.316 250.229 145.217C249.509 140.99 250.56 134.086 255.269 132.358C256.273 131.96 257.364 131.833 258.433 131.989C259.501 132.145 260.51 132.579 261.359 133.248C262.207 133.916 262.865 134.795 263.267 135.798C263.669 136.8 263.801 137.891 263.65 138.96Z",
    fill: "#E4897B"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M258.818 133.747L258.754 129.722C259.8 130.116 260.945 130.166 262.022 129.866C266.659 128.376 270.526 131.112 268.538 133.942C270.85 134.726 269.863 137.88 268.538 139.954C266.681 142.834 264.578 144.274 262.951 143.186C261.511 142.625 260.928 137.923 261.238 136.138C261.698 133.445 258.818 133.747 258.818 133.747Z",
    fill: "#263238"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M265.133 143.626C264.475 144.585 263.506 145.287 262.389 145.613C260.949 145.994 260.525 144.684 261.144 143.33C261.691 142.106 263.102 140.45 264.42 140.666C265.737 140.882 265.961 142.423 265.133 143.626Z",
    fill: "#E4897B"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M256.478 140.062C256.478 140.443 256.234 140.746 255.989 140.738C255.744 140.731 255.557 140.414 255.578 140.018C255.6 139.622 255.823 139.334 256.075 139.342C256.327 139.349 256.507 139.68 256.478 140.062Z",
    fill: "#263238"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M252.18 139.939C252.18 140.321 251.935 140.623 251.69 140.616C251.446 140.609 251.258 140.299 251.28 139.896C251.302 139.493 251.525 139.176 251.777 139.219C252.029 139.262 252.202 139.565 252.18 139.939Z",
    fill: "#263238"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M253.534 140.17C253.007 141.32 252.329 142.395 251.518 143.366C251.769 143.56 252.06 143.696 252.37 143.764C252.68 143.833 253.001 143.832 253.31 143.762L253.534 140.17Z",
    fill: "#DE5753"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M257.897 138.715C257.935 138.707 257.971 138.693 258.005 138.672C258.052 138.637 258.084 138.586 258.095 138.529C258.105 138.471 258.094 138.412 258.062 138.362C257.869 138.069 257.608 137.828 257.3 137.658C256.993 137.489 256.649 137.397 256.298 137.39C256.269 137.39 256.239 137.396 256.212 137.408C256.185 137.42 256.16 137.437 256.14 137.459C256.12 137.48 256.104 137.506 256.094 137.534C256.084 137.562 256.08 137.591 256.082 137.621C256.086 137.679 256.112 137.734 256.155 137.774C256.197 137.815 256.254 137.837 256.313 137.837C256.589 137.845 256.859 137.92 257.1 138.055C257.34 138.191 257.545 138.383 257.695 138.614C257.715 138.649 257.745 138.676 257.781 138.694C257.817 138.712 257.857 138.719 257.897 138.715Z",
    fill: "#263238"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M250.423 138.413C250.461 138.411 250.497 138.399 250.528 138.379C250.56 138.359 250.586 138.331 250.603 138.298C250.735 138.044 250.922 137.824 251.152 137.654C251.382 137.485 251.647 137.37 251.928 137.318C251.957 137.316 251.986 137.307 252.012 137.293C252.038 137.28 252.061 137.261 252.08 137.238C252.099 137.215 252.113 137.189 252.121 137.161C252.13 137.133 252.133 137.103 252.13 137.074C252.127 137.044 252.118 137.016 252.105 136.99C252.091 136.964 252.072 136.94 252.049 136.922C252.026 136.903 252 136.889 251.972 136.88C251.944 136.872 251.914 136.869 251.885 136.872C251.531 136.928 251.195 137.066 250.904 137.275C250.613 137.484 250.374 137.757 250.207 138.074C250.193 138.1 250.185 138.129 250.182 138.158C250.179 138.187 250.182 138.217 250.191 138.245C250.2 138.273 250.214 138.299 250.233 138.322C250.252 138.344 250.275 138.363 250.301 138.377C250.336 138.403 250.379 138.416 250.423 138.413Z",
    fill: "#263238"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M262.346 130.356C262.346 130.356 258.163 124.481 252.23 126.648C252.843 126.689 253.442 126.848 253.994 127.116C253.994 127.116 248.594 127.411 247.464 131.393L248.4 130.673C248.4 130.673 247.485 133.97 249.365 135.792L249.523 134.719C249.523 134.719 252.093 137.124 255.24 135.886L254.03 135.475C254.03 135.475 259.625 134.503 260.813 132.876C261.415 132.095 261.929 131.25 262.346 130.356Z",
    fill: "#263238"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M252.569 145.145C254.384 144.488 256.257 144.006 258.163 143.705C257.911 145.051 257.191 146.246 255.046 146.628C254.785 146.703 254.513 146.724 254.244 146.689C253.975 146.654 253.717 146.564 253.485 146.425C253.252 146.286 253.051 146.101 252.893 145.88C252.736 145.66 252.625 145.41 252.569 145.145Z",
    fill: "#263238"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M255.852 145.49C255.024 145.599 254.251 145.964 253.642 146.534C254.095 146.734 254.6 146.779 255.082 146.664C255.911 146.56 256.685 146.194 257.292 145.62C256.839 145.421 256.333 145.375 255.852 145.49Z",
    fill: "#A02724"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M252.72 145.073C252.79 145.219 252.899 145.343 253.035 145.432C253.171 145.521 253.328 145.571 253.49 145.577C254.728 145.342 255.944 145.005 257.126 144.569C257.32 144.515 257.497 144.414 257.641 144.274C257.786 144.135 257.894 143.961 257.954 143.77C256.179 144.072 254.43 144.508 252.72 145.073Z",
    fill: "white"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M179.042 300.298C182.693 300.298 183.182 300.24 185.234 300.168C186.991 300.11 187.394 300.326 188.834 300.298C190.015 300.298 189.972 299.138 189.605 297.842C189.425 297.187 189.144 295.805 188.885 294.754L183.528 294.365C182.772 295.805 181.073 297.85 179.014 298.13C176.954 298.411 177.588 300.298 179.042 300.298Z",
    fill: "#E31837"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M182.326 288C184.368 286.028 186.175 283.827 187.711 281.441C188.712 280.001 188.899 280.375 189.965 278.978C190.108 278.758 190.197 278.506 190.225 278.245C190.252 277.983 190.218 277.719 190.125 277.473C190.032 277.227 189.882 277.006 189.688 276.829C189.494 276.651 189.261 276.522 189.007 276.451C188.072 276.264 187.157 275.992 186.271 275.638L182.621 278.323C183.291 280.044 182.412 284.89 180.533 286.884C179.187 288.317 181.26 288.979 182.326 288Z",
    fill: "#E31837"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M170.071 199.44C170.071 199.44 159.567 229.464 158.206 240.48C156.881 251.201 182.88 279.151 182.88 279.151C183.514 279.626 186.12 276.386 186.264 275.551C179.784 263.052 175.774 244.534 169.279 239.998C184.853 216.907 187.027 202.14 187.027 202.14L170.071 199.44Z",
    fill: "#263238"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M197.59 148.81C201.226 154.282 200.808 156.967 199.649 167.76C198.49 178.553 202.334 183.089 200.47 188.057C198.605 193.025 185.234 192.607 179.28 182.657C173.326 172.706 180.821 151.322 186.48 149.234C190.059 147.993 193.926 147.845 197.59 148.81Z",
    fill: "#263238"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M177.451 210.002C177.451 210.002 176.595 221.04 176.4 228.55C178.459 224.885 180.13 221.544 181.483 218.556L177.451 210.002Z",
    fill: "black"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M175.162 200.239C175.162 200.239 179.071 230.479 181.31 245.038C183.658 260.316 183.96 284.839 183.37 294.833C184.226 295.33 187.33 294.984 189.014 294.458C189.014 294.458 199.159 261.677 191.707 246.542C196.531 211.183 189.547 202.522 189.547 202.522L175.162 200.239Z",
    fill: "#263238"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M177.739 179.172C174.673 182.765 171.021 185.816 166.939 188.194C159.3 192.643 157.579 179.842 157.342 174.895C157.336 174.536 157.459 174.187 157.689 173.911C157.92 173.636 158.241 173.452 158.595 173.393C158.95 173.335 159.313 173.406 159.62 173.593C159.926 173.78 160.155 174.071 160.265 174.413C160.985 176.573 161.748 178.776 162.612 180.77C163.167 181.951 163.764 183.384 164.628 184.032C164.628 183.838 163.851 183.787 163.714 183.881H163.599L164.599 183.161C167.694 180.799 170.569 178.163 173.189 175.284C175.839 172.541 180.022 176.155 177.718 179.172H177.739Z",
    fill: "#E9B376"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M197.122 179.021C191.664 190.814 190.03 196.963 189.554 202.522L170.071 199.44C170.518 193.003 170.849 189.151 171.317 185.256C171.567 182.59 171.997 179.944 172.606 177.336C173.131 174.564 175.32 171.698 178.013 170.755C178.633 170.527 179.289 170.415 179.95 170.424C180.922 170.424 181.937 170.482 182.916 170.546C185.895 170.806 188.851 171.273 191.765 171.943C192.6 172.123 193.406 172.318 194.17 172.519C194.328 172.562 194.494 172.62 194.645 172.678C195.243 172.908 195.787 173.26 196.241 173.712C196.695 174.164 197.05 174.706 197.283 175.302C197.516 175.899 197.622 176.538 197.595 177.179C197.567 177.819 197.406 178.446 197.122 179.021Z",
    fill: "#E31837"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M192.723 161.863C191.499 164.592 189.727 169.661 191.283 171.85C191.283 171.85 188.655 171.022 182.369 173.65C181.087 171.014 182.434 170.453 182.434 170.453C185.789 170.201 186.25 167.861 186.214 165.593L192.723 161.863Z",
    fill: "#EBB376"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M190.08 163.382L186.214 165.6C186.226 166.134 186.195 166.669 186.12 167.198C187.373 167.198 189.346 166.162 189.771 164.93C189.97 164.438 190.075 163.913 190.08 163.382Z",
    fill: "black"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M197.122 179.021C196.512 180.331 195.95 181.577 195.437 182.758C193.954 186.149 192.83 189.022 191.981 191.534C190.718 195.082 189.903 198.772 189.554 202.522L170.071 199.44C170.518 193.003 170.849 189.151 171.317 185.256C171.567 182.59 171.997 179.944 172.606 177.336C173.131 174.564 175.32 171.698 178.013 170.755C178.633 170.527 179.289 170.415 179.95 170.424C180.922 170.424 181.937 170.482 182.916 170.546C185.895 170.806 188.851 171.273 191.765 171.943C192.6 172.123 193.406 172.318 194.17 172.519C194.328 172.562 194.494 172.62 194.645 172.678C195.243 172.908 195.787 173.26 196.241 173.712C196.695 174.164 197.05 174.706 197.283 175.302C197.516 175.899 197.622 176.538 197.595 177.179C197.567 177.819 197.406 178.446 197.122 179.021Z",
    fill: "white"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M196.056 156.535C194.465 160.999 193.896 162.914 190.915 164.7C186.444 167.393 181.296 164.779 181.519 160.013C181.721 155.693 184.291 149.148 189.274 148.378C190.337 148.177 191.434 148.265 192.452 148.632C193.47 148.998 194.372 149.63 195.064 150.462C195.755 151.294 196.212 152.296 196.386 153.363C196.561 154.431 196.447 155.526 196.056 156.535Z",
    fill: "#EBB376"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M190.8 146.261C187.337 146.261 182.268 149.45 186.667 150.394C186.624 151.834 189.216 151.927 191.124 151.258C190.814 152.287 192.478 154.411 194.868 153.878C193.471 154.562 193.226 158.105 194.868 158.386C196.51 158.666 199.908 159.725 199.613 153.878C199.318 148.032 194.508 146.261 190.8 146.261Z",
    fill: "#263238"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M190.08 156.377C189.958 156.751 189.662 157.018 189.418 156.96C189.173 156.902 189.072 156.542 189.187 156.161C189.302 155.779 189.598 155.52 189.842 155.578C190.087 155.635 190.181 155.995 190.08 156.377Z",
    fill: "#263238"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M185.307 155.102C185.184 155.484 184.896 155.743 184.644 155.686C184.392 155.628 184.299 155.275 184.414 154.894C184.529 154.512 184.824 154.253 185.069 154.31C185.314 154.368 185.422 154.721 185.307 155.102Z",
    fill: "#263238"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M185.177 154.353L184.349 153.878C184.349 153.878 184.594 154.699 185.177 154.353Z",
    fill: "#263238"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M186.48 156.283C185.875 157.071 185.174 157.78 184.392 158.393C184.545 158.577 184.739 158.723 184.957 158.822C185.175 158.92 185.413 158.968 185.652 158.961L186.48 156.283Z",
    fill: "#D58745"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M187.416 160.877C187.198 160.862 186.981 160.831 186.768 160.783C186.753 160.78 186.738 160.774 186.726 160.764C186.713 160.755 186.703 160.743 186.695 160.729C186.688 160.716 186.683 160.701 186.682 160.685C186.681 160.669 186.683 160.654 186.689 160.639C186.699 160.61 186.719 160.586 186.746 160.572C186.772 160.557 186.803 160.553 186.833 160.56C187.314 160.677 187.816 160.683 188.3 160.576C188.784 160.47 189.238 160.255 189.626 159.948C189.637 159.937 189.65 159.928 189.664 159.922C189.679 159.916 189.694 159.913 189.709 159.913C189.725 159.913 189.74 159.916 189.754 159.922C189.768 159.928 189.781 159.937 189.792 159.948C189.803 159.958 189.812 159.97 189.818 159.984C189.824 159.998 189.827 160.012 189.827 160.027C189.827 160.042 189.824 160.057 189.818 160.07C189.812 160.084 189.803 160.096 189.792 160.106C189.124 160.65 188.276 160.925 187.416 160.877Z",
    fill: "#263238"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M196.481 160.618C195.78 161.339 194.822 161.753 193.817 161.77C192.528 161.77 192.327 160.438 193.047 159.336C193.767 158.234 195.156 157.14 196.272 157.68C197.388 158.22 197.374 159.703 196.481 160.618Z",
    fill: "#EBB376"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M191.52 154.159C191.49 154.154 191.461 154.144 191.435 154.128C191.409 154.111 191.387 154.09 191.369 154.066C191.222 153.825 191.017 153.625 190.773 153.484C190.529 153.343 190.254 153.266 189.972 153.259C189.913 153.259 189.856 153.236 189.814 153.194C189.773 153.152 189.749 153.095 189.749 153.036C189.754 152.975 189.781 152.917 189.824 152.873C189.868 152.83 189.925 152.803 189.987 152.798C190.343 152.801 190.694 152.894 191.005 153.069C191.316 153.244 191.577 153.496 191.765 153.799C191.797 153.851 191.808 153.913 191.794 153.972C191.781 154.032 191.744 154.083 191.693 154.116C191.642 154.15 191.581 154.166 191.52 154.159Z",
    fill: "#263238"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M184.111 152.136C184.083 152.137 184.055 152.132 184.028 152.12C184.002 152.109 183.979 152.092 183.96 152.071C183.938 152.05 183.921 152.025 183.909 151.997C183.897 151.969 183.89 151.939 183.89 151.909C183.89 151.879 183.897 151.849 183.909 151.821C183.921 151.793 183.938 151.768 183.96 151.747C184.22 151.476 184.539 151.27 184.893 151.145C185.247 151.019 185.625 150.979 185.998 151.027C186.026 151.033 186.053 151.045 186.077 151.061C186.101 151.078 186.121 151.1 186.136 151.125C186.151 151.15 186.16 151.178 186.164 151.207C186.167 151.236 186.165 151.266 186.156 151.294C186.141 151.353 186.103 151.405 186.051 151.439C185.999 151.472 185.936 151.485 185.875 151.474C185.58 151.441 185.282 151.476 185.003 151.576C184.723 151.676 184.47 151.838 184.262 152.05C184.224 152.095 184.17 152.125 184.111 152.136Z",
    fill: "#263238"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M189.929 155.628L189.108 155.153C189.108 155.153 189.36 155.974 189.929 155.628Z",
    fill: "#263238"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M181.08 170.899C177.278 169.459 174.262 171.238 169.646 176.45C169.97 179.122 174.463 183.146 174.463 183.146C174.463 183.146 182.16 175.838 181.08 170.899Z",
    fill: "#E31837"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M194.645 172.656C193.074 173.462 191.462 174.183 189.814 174.816C189.389 174.967 188.957 175.126 188.518 175.27C186.012 176.112 183.391 176.638 181.519 176.083C180.703 175.905 179.953 175.499 179.357 174.913C178.761 174.327 178.342 173.585 178.15 172.771C177.99 172.095 177.946 171.396 178.02 170.705C178.64 170.477 179.297 170.365 179.957 170.374H180.612C180.9 170.374 181.174 170.374 181.462 170.374L182.902 170.453C185.88 170.713 188.837 171.179 191.751 171.85L191.938 171.893L192.593 172.037C193.126 172.159 193.651 172.289 194.155 172.426C194.328 172.541 194.494 172.598 194.645 172.656Z",
    fill: "#EBB376"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M192.607 172.08C191.57 172.877 190.632 173.795 189.814 174.816C189.389 174.967 188.957 175.126 188.518 175.27C189.456 173.961 190.622 172.832 191.959 171.936L192.607 172.08Z",
    fill: "#263238"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M181.44 170.446C180.306 171.381 179.29 172.452 178.416 173.635C178.294 173.367 178.197 173.087 178.128 172.8C178.845 171.907 179.672 171.108 180.591 170.424C180.893 170.424 181.167 170.438 181.44 170.446Z",
    fill: "#263238"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.607 172.08C191.57 172.877 190.632 173.795 189.814 174.816C189.389 174.967 188.957 175.126 188.518 175.27C189.456 173.961 190.622 172.832 191.959 171.936L192.607 172.08Z",
    fill: "white"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M181.44 170.446C180.306 171.381 179.29 172.452 178.416 173.635C178.294 173.367 178.197 173.087 178.128 172.8C178.845 171.907 179.672 171.108 180.591 170.424C180.893 170.424 181.167 170.438 181.44 170.446Z",
    fill: "white"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M195.437 182.758C193.954 186.149 192.831 189.022 191.981 191.534C184.875 187.135 190.743 179.726 190.743 179.726C192.535 180.33 194.149 181.372 195.437 182.758Z",
    fill: "black"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M159.898 150.89C143.223 149.933 130.551 162.777 129.219 186.17C129.091 188.297 129.074 190.428 129.168 192.557C128.448 214.956 139.435 228.499 155.7 229.428C172.375 230.378 185.047 217.533 186.379 194.148C186.507 192.021 186.524 189.89 186.43 187.761C187.142 165.362 176.163 151.819 159.898 150.89ZM164.995 188.229C164.225 201.852 160.913 205.913 156.766 205.682C153.403 205.488 150.912 202.543 150.509 194.162C150.509 193.5 150.559 192.816 150.595 192.103C151.373 178.481 154.678 174.42 158.825 174.657C162.194 174.845 164.686 177.789 165.089 186.177C165.067 186.84 165.039 187.517 164.995 188.229Z",
    fill: "#E31837"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M186.365 182.419C186.365 182.081 186.365 181.742 186.3 181.404C186.329 181.742 186.343 182.081 186.365 182.419Z",
    fill: "black"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.139 191.786C129.139 191.47 129.139 191.153 129.139 190.836C129.118 191.153 129.132 191.47 129.139 191.786Z",
    fill: "black"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.218 186.3C130.55 162.885 143.222 150.041 159.898 151.02C173.938 151.819 184.046 162.014 186.091 179.201C184.075 161.921 173.966 151.711 159.898 150.912C143.222 149.954 130.55 162.799 129.218 186.192C129.175 186.912 129.146 187.632 129.132 188.352C129.146 187.69 129.175 186.998 129.218 186.3Z",
    fill: "black"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M186.437 184.025C186.437 183.859 186.437 183.701 186.437 183.535C186.43 183.694 186.43 183.859 186.437 184.025Z",
    fill: "black"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.111 190.174C129.111 189.662 129.111 189.151 129.111 188.633C129.118 189.151 129.111 189.662 129.111 190.174Z",
    fill: "black"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M186.365 189.554C185.026 212.969 172.354 225.806 155.678 224.834C140.558 223.977 130.025 212.241 129.161 192.636C128.477 214.956 139.45 228.499 155.7 229.428C172.375 230.378 185.047 217.533 186.379 194.148C186.507 192.043 186.524 189.933 186.43 187.826C186.415 188.397 186.394 188.973 186.365 189.554Z",
    fill: "black"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.581 187.517C149.803 201.139 152.626 205.553 156.773 205.783C160.92 206.014 164.225 201.96 165.002 188.338C165.78 174.715 162.951 170.338 158.811 170.064C154.671 169.79 151.351 173.894 150.581 187.517ZM165.089 186.17C165.089 186.84 165.039 187.517 164.995 188.23C164.225 201.852 160.913 205.913 156.766 205.682C153.403 205.488 150.912 202.543 150.509 194.162C150.509 193.5 150.559 192.816 150.595 192.103C151.373 178.481 154.678 174.42 158.825 174.658C162.194 174.845 164.686 177.79 165.089 186.17Z",
    fill: "black"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M154.375 172.8L154.577 174.067C154.614 174.304 154.707 174.528 154.848 174.721C154.99 174.914 155.176 175.07 155.391 175.176L157.414 176.184C157.812 176.383 158.252 176.483 158.697 176.476C159.142 176.468 159.579 176.353 159.97 176.141L160.467 175.882C160.272 173.722 158.501 171.562 158.501 171.562L158.062 170.885C157.975 170.745 157.861 170.623 157.727 170.527C157.594 170.431 157.442 170.362 157.281 170.325C157.121 170.287 156.955 170.282 156.792 170.309C156.629 170.336 156.474 170.394 156.334 170.482L154.995 171.36C154.763 171.515 154.582 171.733 154.472 171.988C154.362 172.244 154.328 172.526 154.375 172.8Z",
    fill: "#EBB376"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M170.007 186.034L171.447 185.717C171.713 185.657 171.99 185.662 172.254 185.731C172.518 185.799 172.762 185.931 172.966 186.113L174.888 187.848C175.268 188.187 175.56 188.613 175.74 189.089C175.921 189.566 175.984 190.078 175.925 190.584L175.853 191.225C173.506 191.945 170.46 190.937 170.46 190.937L169.56 190.75C169.187 190.681 168.855 190.468 168.638 190.157C168.421 189.845 168.336 189.46 168.401 189.086L168.739 187.301C168.807 186.99 168.962 186.706 169.187 186.481C169.411 186.256 169.696 186.101 170.007 186.034Z",
    fill: "#EBB376"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M197.417 182.534C196.138 188.103 193.683 193.335 190.217 197.878C185.537 202.846 176.019 193.687 172.649 190.303C172.405 190.039 172.266 189.695 172.255 189.336C172.245 188.977 172.365 188.626 172.593 188.348C172.821 188.07 173.141 187.884 173.496 187.824C173.85 187.764 174.214 187.834 174.521 188.021C176.796 189.461 179.179 190.944 181.555 192.19C183.147 192.996 184.824 193.882 186.444 194.062C186.97 194.062 186.631 193.932 186.3 194.213L185.911 194.63C186.563 193.634 187.159 192.603 187.697 191.542C189.323 188.177 190.63 184.667 191.599 181.058C191.854 180.363 192.358 179.786 193.014 179.441C193.669 179.096 194.429 179.007 195.147 179.191C195.865 179.375 196.488 179.819 196.897 180.437C197.306 181.054 197.471 181.802 197.359 182.534H197.417Z",
    fill: "#E9B376"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M195.675 173.189C198.994 175.543 199.152 179.057 197.359 185.789C194.955 186.991 189.123 185.472 189.123 185.472C189.123 185.472 190.959 175.018 195.675 173.189Z",
    fill: "#E31837"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M195.675 173.189C198.994 175.543 199.152 179.057 197.359 185.789C194.955 186.991 189.123 185.472 189.123 185.472C189.123 185.472 190.959 175.018 195.675 173.189Z",
    fill: "white"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M132.703 289.512L137.175 287.892L134.712 277.114L130.241 278.734L132.703 289.512Z",
    fill: "#FFC3BD"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4304 295.452H102.175L103.529 284.458H98.7768L97.4304 295.452Z",
    fill: "#FFC3BD"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M102.802 294.905H97.0416C96.9474 294.904 96.8559 294.936 96.7825 294.995C96.7091 295.054 96.6582 295.137 96.6384 295.229L95.6592 299.448C95.6412 299.552 95.6464 299.659 95.6744 299.761C95.7024 299.863 95.7526 299.958 95.8214 300.038C95.8901 300.119 95.9757 300.183 96.0721 300.227C96.1686 300.27 96.2734 300.292 96.3792 300.29C98.244 300.254 99.5976 300.146 101.945 300.146C103.385 300.146 107.741 300.298 109.728 300.298C111.715 300.298 112.003 298.332 111.168 298.138C107.518 297.338 104.774 296.23 103.615 295.178C103.389 294.986 103.098 294.889 102.802 294.905Z",
    fill: "#263238"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M137.34 286.978L132.257 288.072C132.165 288.091 132.083 288.141 132.023 288.213C131.963 288.284 131.929 288.374 131.926 288.468L131.854 292.788C131.859 292.889 131.885 292.989 131.93 293.079C131.976 293.17 132.041 293.25 132.12 293.314C132.199 293.377 132.29 293.424 132.388 293.45C132.486 293.476 132.589 293.481 132.689 293.465C134.518 293.04 137.146 292.37 139.45 291.874C142.143 291.298 143.813 290.75 146.967 290.074C148.875 289.663 149.011 287.626 148.176 287.626C144.375 287.626 142.071 288.346 138.535 287.093C138.155 286.944 137.742 286.905 137.34 286.978Z",
    fill: "#263238"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.712 277.114L135.979 282.672L131.508 284.292L130.241 278.741L134.712 277.114Z",
    fill: "black"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M98.7768 284.465H103.529L102.83 290.131H98.0784L98.7768 284.465Z",
    fill: "black"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M137.29 281.03L129.722 283.774C129.722 283.774 123.84 257.76 120.658 243.288C119.264 237.573 117.542 231.943 115.502 226.426C112.622 218.318 109.202 209.592 106.43 202.774C103.507 195.574 101.333 190.534 101.333 190.534L117.706 187.222C117.706 187.222 130.198 223.164 133.006 237.377C135.922 252.13 137.29 281.03 137.29 281.03Z",
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.29 281.03L129.722 283.774C129.722 283.774 123.84 257.76 120.658 243.288C119.264 237.573 117.542 231.943 115.502 226.426C112.622 218.318 109.202 209.592 106.43 202.774C103.507 195.574 101.333 190.534 101.333 190.534L117.706 187.222C117.706 187.222 130.198 223.164 133.006 237.377C135.922 252.13 137.29 281.03 137.29 281.03Z",
    fill: "white"
  }))), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.502 226.426C112.622 218.318 109.202 209.592 106.43 202.774L107.698 198.857C112.385 203.191 115.308 218.16 115.502 226.426Z",
    fill: "black"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M108.871 188.993C108.871 188.993 111.794 229.982 111.974 243.907C112.169 259.157 105.034 289.03 105.034 289.03H96.3432C96.3432 289.03 99.8136 262.08 98.64 246.96C97.344 230.069 92.7864 192.24 92.7864 192.24L108.871 188.993Z",
    fill: "#263238"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.871 188.993C108.871 188.993 111.794 229.982 111.974 243.907C112.169 259.157 105.034 289.03 105.034 289.03H96.3432C96.3432 289.03 99.8136 262.08 98.64 246.96C97.344 230.069 92.7864 192.24 92.7864 192.24L108.871 188.993Z",
    fill: "white"
  }))), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M106.071 289.217H95.8394L95.8682 286.157L106.553 285.545L106.071 289.217Z",
    fill: "#263238"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M138.305 280.93L129.233 284.083L128.247 281.153L138.168 277.546L138.305 280.93Z",
    fill: "#263238"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M103.126 295.56C103.104 295.556 103.084 295.546 103.069 295.53C103.054 295.515 103.043 295.495 103.039 295.474C103.035 295.452 103.038 295.429 103.047 295.409C103.056 295.388 103.071 295.371 103.09 295.358C103.262 295.25 104.81 294.307 105.329 294.581C105.387 294.61 105.436 294.655 105.469 294.712C105.502 294.768 105.519 294.832 105.516 294.898C105.528 295.008 105.513 295.12 105.472 295.223C105.43 295.326 105.364 295.417 105.278 295.488C105.01 295.67 104.688 295.757 104.364 295.733C103.946 295.722 103.53 295.664 103.126 295.56ZM103.45 295.402C104.001 295.594 104.606 295.563 105.134 295.315C105.192 295.266 105.236 295.204 105.264 295.133C105.292 295.063 105.301 294.987 105.293 294.912C105.293 294.818 105.257 294.79 105.221 294.775C105.173 294.766 105.124 294.766 105.077 294.775C104.5 294.879 103.947 295.092 103.45 295.402Z",
    fill: "#E31837"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M103.09 295.546C103.071 295.537 103.057 295.522 103.047 295.504C103.038 295.485 103.035 295.465 103.039 295.445C103.039 295.387 103.169 294.005 103.759 293.566C103.824 293.51 103.9 293.469 103.982 293.444C104.063 293.419 104.149 293.411 104.234 293.422C104.32 293.42 104.403 293.449 104.468 293.503C104.534 293.557 104.579 293.633 104.594 293.717C104.688 294.242 103.723 295.286 103.234 295.553H103.176C103.162 295.56 103.147 295.563 103.132 295.562C103.116 295.561 103.102 295.555 103.09 295.546ZM103.867 293.738C103.532 294.167 103.331 294.686 103.291 295.229C103.781 294.854 104.4 294.07 104.342 293.789C104.342 293.789 104.342 293.688 104.177 293.674H104.126C104.033 293.671 103.941 293.702 103.867 293.76V293.738Z",
    fill: "#E31837"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M146.369 129.276L150.171 125.186L152.446 130.946C152.446 130.946 148.846 134.388 147.139 132.458L146.369 129.276Z",
    fill: "#FFC3BD"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M155.498 123.682L155.772 129.298L152.446 130.946L150.17 125.186L155.498 123.682Z",
    fill: "#FFC3BD"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M137.837 287.453C137.83 287.43 137.829 287.406 137.836 287.383C137.842 287.36 137.855 287.339 137.873 287.323C138.06 287.172 139.731 285.818 140.364 286.013C140.424 286.032 140.477 286.065 140.52 286.111C140.563 286.156 140.593 286.212 140.609 286.272C140.64 286.369 140.647 286.472 140.63 286.573C140.612 286.673 140.57 286.767 140.508 286.848C140.091 287.41 138.723 287.51 137.945 287.525C137.922 287.524 137.9 287.517 137.881 287.504C137.861 287.492 137.846 287.474 137.837 287.453ZM138.276 287.287C139.342 287.237 140.098 287.028 140.328 286.718C140.371 286.664 140.399 286.6 140.41 286.532C140.422 286.464 140.416 286.395 140.393 286.33C140.393 286.279 140.35 286.243 140.299 286.229H140.256C139.875 286.178 138.96 286.776 138.276 287.28V287.287Z",
    fill: "#E31837"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5633 152.05C79.4665 153.662 66.5137 164.29 66.0313 168.919C65.5489 173.549 80.6761 178.733 80.6761 178.733L84.3481 175.615C84.3481 175.615 75.1393 168.538 75.1393 167.695C75.1393 166.853 86.6593 160.769 86.6593 160.769C87.4879 158.79 87.5924 156.582 86.9545 154.534C86.1913 152.395 83.5633 152.05 83.5633 152.05Z",
    fill: "#263238"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M109.685 146.995C115.812 146.527 126.914 143.028 129.895 141.12C132.876 139.212 146.369 128.765 146.369 128.765L150.214 133.193C150.214 133.193 140.054 144.994 134.23 148.81C128.405 152.626 112.558 158.638 112.558 158.638L109.685 146.995Z",
    fill: "#263238"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M137.895 287.51C137.877 287.502 137.863 287.49 137.851 287.475C137.84 287.46 137.833 287.443 137.83 287.424C137.741 286.755 137.864 286.075 138.183 285.48C138.252 285.39 138.338 285.316 138.437 285.261C138.537 285.207 138.646 285.173 138.759 285.163C139.068 285.127 139.183 285.264 139.234 285.379C139.421 285.89 138.514 287.129 138.01 287.503H137.931L137.895 287.51ZM138.78 285.386C138.697 285.393 138.617 285.417 138.545 285.458C138.472 285.499 138.41 285.556 138.363 285.624C138.096 286.099 137.983 286.645 138.039 287.186C138.543 286.718 139.133 285.746 139.018 285.466C139.018 285.466 139.018 285.394 138.895 285.386H138.78Z",
    fill: "#E31837"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5632 152.05C84.2832 153.806 84.96 155.585 85.5648 157.363C86.232 159.322 86.8368 161.27 87.3792 163.21C87.7536 164.534 88.0992 165.859 88.416 167.155C88.5312 167.594 88.632 168.041 88.7328 168.473C88.9848 169.517 89.208 170.546 89.4528 171.562C89.6976 172.577 89.8488 173.484 90.0288 174.442C90.2088 175.399 90.4104 176.422 90.576 177.372C90.7416 178.322 90.8928 179.237 91.0368 180.122C91.1808 181.008 91.3392 182.059 91.4688 183.002C91.6344 184.14 91.7784 185.206 91.908 186.185C92.3112 189.13 92.5848 191.282 92.8296 192.312L117.734 187.272C117.734 185.321 117.734 183.442 117.641 181.627C117.598 180.418 117.54 179.244 117.454 178.099C117.41 177.343 117.353 176.602 117.288 175.867C117.194 174.758 117.086 173.707 116.971 172.627C116.827 171.454 116.676 170.323 116.51 169.229C116.208 167.213 115.872 165.338 115.502 163.606C115.049 161.503 114.566 159.602 114.062 157.903C113.443 155.743 112.81 153.958 112.234 152.453C111.545 150.586 110.697 148.782 109.699 147.06C107.668 146.947 105.631 146.961 103.601 147.103C103.169 147.103 102.737 147.175 102.298 147.226C98.7281 147.738 95.1916 148.459 91.7064 149.386C91.0512 149.551 90.3744 149.746 89.7264 149.94C87.6377 150.539 85.5806 151.243 83.5632 152.05Z",
    fill: "#263238"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M90 137.131C91.44 140.414 93.4344 146.491 91.3752 149.278C92.7418 150.173 94.2769 150.78 95.8865 151.061C97.496 151.342 99.146 151.291 100.735 150.912C103.838 150.271 103.565 148.183 102.636 147.182C98.4168 147.024 97.9272 144.18 98.0784 141.422L90 137.131Z",
    fill: "#FFC3BD"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.26 138.96L98.0568 141.372C98.0097 142.02 98.0241 142.671 98.1 143.316C93.2256 144.626 91.2024 139.363 91.26 138.96Z",
    fill: "black"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M106.661 217.375L114.847 200.815L113.479 195.286L110.39 193.766L113.27 187.97L111.895 182.441L100.296 176.717L122.616 159.89L121.248 154.368L104.623 146.16L65.0233 175.075L58.3201 188.64L59.6953 194.17L81.2953 204.833L77.8537 211.802L79.2217 217.332L94.9249 225.086L100.296 214.207L106.661 217.375ZM91.8721 184.594L90.6121 183.974L93.1033 182.095L91.8721 184.594Z",
    fill: "#E31837"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.39 193.738L113.249 187.942L111.888 182.412L100.282 176.688L122.587 159.862L121.219 154.332L104.623 146.146L65.0232 175.061L64.98 175.14L104.573 146.232L121.169 154.426L85.2984 181.469L91.8144 184.687L91.8648 184.594L90.612 183.974L93.0888 182.11L96.6024 174.989L111.83 182.506L107.042 192.204L113.422 195.35L105.235 211.939L98.856 208.786L93.4848 219.665L77.868 211.954L79.2072 217.346L94.9104 225.101L100.282 214.222L106.661 217.368L114.847 200.786L113.479 195.257L110.39 193.738Z",
    fill: "black"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M83.1528 201.038L58.3416 188.791L59.6808 194.184L81.2736 204.84L83.1528 201.038Z",
    fill: "black"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3689 175.615L88.6609 177.401L84.3409 181.843C84.3409 181.843 79.7113 179.971 80.7409 177.631L83.3689 175.615Z",
    fill: "#FFC3BD"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2249 181.627L87.2137 184.19L84.3481 181.843L88.6609 177.394L92.2249 181.627Z",
    fill: "#FFC3BD"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7392 121.889C100.901 122.062 102.499 130.759 101.218 132.178C98.7768 134.82 91.584 121.68 96.7392 121.889Z",
    fill: "#263238"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7178 133.128C89.7842 137.75 90.7634 140.558 94.061 142.092C99.029 144.396 104.055 140.033 103.421 134.892C102.838 130.262 99.5546 123.48 94.2122 123.336C93.0354 123.298 91.8684 123.561 90.822 124.101C89.7757 124.641 88.8848 125.44 88.2341 126.421C87.5833 127.402 87.1942 128.533 87.1039 129.707C87.0135 130.881 87.2248 132.059 87.7178 133.128Z",
    fill: "#FFC3BD"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8 131.58C84.3264 134.618 89.4888 139.831 91.26 138.989C93.1752 138.067 92.1456 133.553 89.6976 130.025L82.8 131.58Z",
    fill: "#263238"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5376 139.147C88.04 139.529 88.6129 139.807 89.2233 139.967C89.8337 140.126 90.4696 140.163 91.0944 140.076C92.7648 139.838 92.9232 138.182 91.8936 136.958C90.9576 135.857 88.9704 134.662 87.5736 135.518C87.2685 135.711 87.0165 135.977 86.8408 136.293C86.665 136.608 86.5711 136.962 86.5675 137.323C86.5639 137.684 86.6508 138.04 86.8203 138.359C86.9897 138.677 87.2364 138.948 87.5376 139.147Z",
    fill: "#FFC3BD"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M95.393 131.76C95.537 132.149 95.8538 132.379 96.113 132.286C96.3722 132.192 96.4514 131.803 96.3074 131.414C96.1634 131.026 95.8466 130.795 95.5874 130.889C95.3282 130.982 95.249 131.371 95.393 131.76Z",
    fill: "#263238"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7417 130.118C99.8929 130.5 100.21 130.738 100.462 130.644C100.714 130.55 100.8 130.162 100.656 129.773C100.512 129.384 100.188 129.154 99.9361 129.247C99.6841 129.341 99.5977 129.73 99.7417 130.118Z",
    fill: "#263238"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4312 130.831C99.3337 131.835 100.371 132.71 101.513 133.43C101.319 133.717 101.066 133.958 100.77 134.138C100.474 134.317 100.143 134.429 99.7991 134.467L98.4312 130.831Z",
    fill: "#ED847E"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0936 135.95C99.1189 135.935 99.1384 135.912 99.1489 135.885C99.1594 135.857 99.1602 135.827 99.1512 135.799C99.1456 135.784 99.137 135.77 99.126 135.758C99.115 135.746 99.1018 135.737 99.087 135.73C99.0723 135.723 99.0564 135.72 99.0402 135.719C99.024 135.719 99.0079 135.721 98.9928 135.727C98.5174 135.919 98.0034 135.995 97.4929 135.95C96.9823 135.905 96.4896 135.74 96.0552 135.468C96.0445 135.457 96.0316 135.448 96.0174 135.442C96.0031 135.436 95.9878 135.433 95.9724 135.433C95.9569 135.433 95.9417 135.436 95.9274 135.442C95.9132 135.448 95.9003 135.457 95.8896 135.468C95.8785 135.479 95.8697 135.492 95.8636 135.506C95.8576 135.52 95.8545 135.535 95.8545 135.551C95.8545 135.566 95.8576 135.582 95.8636 135.596C95.8697 135.61 95.8785 135.623 95.8896 135.634C96.3554 135.933 96.8863 136.116 97.4376 136.167C97.9889 136.219 98.5445 136.137 99.0576 135.929L99.0936 135.95Z",
    fill: "#263238"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6001 130.831C93.629 130.817 93.6547 130.796 93.6757 130.772C93.6967 130.747 93.7126 130.718 93.7225 130.687C93.8005 130.393 93.9468 130.122 94.1495 129.896C94.3522 129.669 94.6055 129.494 94.8889 129.384C94.9494 129.364 94.9999 129.321 95.0295 129.265C95.0591 129.209 95.0654 129.143 95.0473 129.082C95.0383 129.051 95.0232 129.023 95.003 128.998C94.9828 128.973 94.9578 128.953 94.9296 128.938C94.9014 128.924 94.8705 128.915 94.8388 128.912C94.807 128.909 94.7751 128.913 94.7449 128.923C94.3849 129.056 94.0619 129.273 93.8027 129.556C93.5435 129.839 93.3555 130.18 93.2545 130.55C93.2457 130.581 93.2431 130.612 93.2467 130.644C93.2503 130.675 93.2601 130.705 93.2755 130.733C93.2909 130.76 93.3116 130.784 93.3364 130.804C93.3613 130.823 93.3897 130.837 93.4201 130.846C93.4494 130.856 93.4806 130.86 93.5116 130.857C93.5426 130.855 93.5727 130.846 93.6001 130.831Z",
    fill: "#263238"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M101.117 127.894L101.182 127.843C101.204 127.821 101.222 127.795 101.234 127.766C101.246 127.737 101.252 127.705 101.252 127.674C101.252 127.642 101.246 127.611 101.234 127.582C101.222 127.553 101.204 127.527 101.182 127.505C100.911 127.233 100.578 127.03 100.212 126.915C99.8458 126.8 99.4571 126.775 99.0793 126.842C99.0484 126.849 99.0191 126.862 98.9933 126.88C98.9674 126.898 98.9455 126.922 98.9287 126.949C98.9119 126.975 98.9007 127.005 98.8956 127.036C98.8906 127.068 98.8918 127.1 98.8993 127.13C98.9162 127.192 98.9562 127.246 99.0111 127.279C99.066 127.312 99.1316 127.324 99.1945 127.31C99.4941 127.264 99.8005 127.289 100.088 127.385C100.376 127.48 100.637 127.642 100.85 127.858C100.887 127.888 100.931 127.908 100.978 127.914C101.026 127.92 101.074 127.913 101.117 127.894Z",
    fill: "#263238"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2561 136.08C85.0861 135.335 84.0826 134.356 83.3083 133.205C82.534 132.054 82.0056 130.756 81.7561 129.391C80.9497 124.783 89.2585 120.182 93.8881 119.822C98.5177 119.462 97.7833 124.531 97.7833 124.531C97.7833 124.531 91.7857 126.691 89.7193 127.98C87.6529 129.269 89.7193 130.032 89.7193 130.032L86.2561 136.08Z",
    fill: "#263238"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1392 167.76C75.1392 167.71 75.1824 167.645 75.2616 167.558H66.4632C66.2433 167.997 66.0974 168.469 66.0312 168.955C65.556 173.563 80.676 178.769 80.676 178.769L84.348 175.651C84.348 175.651 75.1392 168.538 75.1392 167.76Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.8b7e9f1a7b7d7e99c391b361ded15650.svg";
export { ForwardRef as ReactComponent };